(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["electronic-badge-fifth-screen"] && !Shopify.designMode) return;
  try {
    
  class ElectronicBadgeFifthScreen extends HTMLElement {
    connectedCallback() {
      if (this.dataset.fifthScreenReady === 'true') return;
      this.dataset.fifthScreenReady = 'true';

      this.orbitSlots = Array.from(this.querySelectorAll('[data-fifth-orbit-slot]'));
      this.slides = Array.from(this.querySelectorAll('[data-fifth-slide]'));
      this.indicators = Array.from(this.querySelectorAll('[data-fifth-indicator]'));
      this.previousButton = this.querySelector('[data-fifth-previous]');
      this.nextButton = this.querySelector('[data-fifth-next]');
      this.leftEdge = this.querySelector('[data-fifth-edge-left]');
      this.rightEdge = this.querySelector('[data-fifth-edge-right]');
      this.count = this.slides.length;
      this.current = 0;
      this.interval = 3000;
      this.isVisible = false;
      this.isPrepared = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.count) return;

      this.onBlockSelect = this.onBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => this.setCurrent(index));
      });
      this.previousButton?.addEventListener('click', () => this.setCurrent(this.current - 1));
      this.nextButton?.addEventListener('click', () => this.setCurrent(this.current + 1));

      this.setCurrent(0, false);

      if (typeof IntersectionObserver === 'undefined' || window.Shopify?.designMode) {
        this.prepare();
        this.isVisible = true;
        this.setCurrent(this.current);
        return;
      }

      this.prewarmObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.prepare();
            this.setCurrent(this.current, false);
          } else if (this.isPrepared && !this.isVisible) {
            this.releaseOffscreenMedia();
          }
        },
        {
          rootMargin: '200px 0px',
          threshold: 0
        }
      );
      this.prewarmObserver.observe(this);

      this.observer = new IntersectionObserver(
        (entries) => {
          this.isVisible = entries.some((entry) => entry.isIntersecting);
          if (this.isVisible) {
            this.prepare();
            this.setCurrent(this.current);
          } else {
            this.stopTimer();
            this.releaseOffscreenMedia();
          }
        },
        {
          threshold: 0.01
        }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stopTimer();
      this.observer?.disconnect();
      this.prewarmObserver?.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    normalize(index) {
      return ((index % this.count) + this.count) % this.count;
    }

    prepare() {
      if (this.isPrepared) return;
      this.isPrepared = true;
      this.setCurrent(this.current, false);
    }

    getTemplateImage(index, selector) {
      const slide = this.slides[this.normalize(index)];
      const template = slide?.querySelector(selector);
      return template?.content.querySelector('img') || null;
    }

    getSourceImage(index) {
      return (
        this.getTemplateImage(index, '[data-fifth-preview-template]') ||
        this.getTemplateImage(index, '[data-fifth-gif-template]')
      );
    }

    mountSlideImage(index) {
      const slide = this.slides[this.normalize(index)];
      if (!slide || slide.querySelector('.electronic-badge-fifth-screen__slide-image')) return;
      const sourceImage = this.getTemplateImage(index, '[data-fifth-gif-template]');
      if (sourceImage) slide.appendChild(sourceImage.cloneNode(true));
    }

    syncSlideMedia() {
      const nextIndex = this.normalize(this.current + 1);

      this.slides.forEach((slide, index) => {
        if (index === this.current || index === nextIndex) {
          this.mountSlideImage(index);
        } else {
          slide.querySelector('.electronic-badge-fifth-screen__slide-image')?.remove();
        }
      });
    }

    cloneOrbitImage(index) {
      const sourceImage = this.getSourceImage(index);
      if (!sourceImage) return null;

      const image = sourceImage.cloneNode(true);
      image.classList.remove('electronic-badge-fifth-screen__static-preview');
      image.classList.add('electronic-badge-fifth-screen__orbit-image');
      return image;
    }

    updateEdgePeek(container, sourceIndex) {
      if (!container) return;
      container.replaceChildren();
      container.classList.remove('is-visible');
      if (this.count <= 7) return;

      const image = this.cloneOrbitImage(sourceIndex);
      if (!image) return;

      container.appendChild(image);
      container.classList.add('is-visible');
    }

    updateOrbitSlots() {
      const populatedSlotCount = Math.min(this.orbitSlots.length, Math.max(0, this.count - 1));

      this.orbitSlots.forEach((slot) => {
        slot.replaceChildren();
        slot.classList.remove('is-populated');
        if (Number(slot.dataset.fifthRank) > populatedSlotCount) return;

        const image = this.cloneOrbitImage(this.current + Number(slot.dataset.fifthOffset));
        if (!image) return;

        slot.appendChild(image);
        slot.classList.add('is-populated');
      });
    }

    releaseOffscreenMedia() {
      this.slides.forEach((slide) => {
        slide.querySelector('.electronic-badge-fifth-screen__slide-image')?.remove();
      });
      this.orbitSlots.forEach((slot) => {
        slot.replaceChildren();
        slot.classList.remove('is-populated');
      });
      [this.leftEdge, this.rightEdge].forEach((edge) => {
        edge?.replaceChildren();
        edge?.classList.remove('is-visible');
      });
    }

    setCurrent(index, restart = true) {
      this.current = this.normalize(index);
      this.interval = Math.min(
        10000,
        Math.max(3000, Number(this.slides[this.current]?.dataset.fifthDuration) || 3000)
      );
      this.style.setProperty('--fifth-switch-duration', `${this.interval}ms`);

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.current;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      if (this.isPrepared) {
        this.syncSlideMedia();
        this.updateOrbitSlots();
        this.updateEdgePeek(this.leftEdge, this.current - 4);
        this.updateEdgePeek(this.rightEdge, this.current + 4);
      }

      this.indicators.forEach((indicator, indicatorIndex) => {
        indicator.classList.remove('is-active');
        indicator.setAttribute('aria-current', 'false');
        if (indicatorIndex === this.current) indicator.offsetWidth;
      });

      const currentIndicator = this.indicators[this.current];
      if (currentIndicator) {
        currentIndicator.classList.add('is-active');
        currentIndicator.setAttribute('aria-current', 'true');
      }

      if (restart) this.startTimer();
    }

    startTimer() {
      this.stopTimer();
      if (!this.isPrepared || !this.isVisible || this.reduceMotion || this.interval <= 0 || this.count <= 1) {
        return;
      }
      this.timer = window.setTimeout(() => this.setCurrent(this.current + 1), this.interval);
    }

    stopTimer() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
    }

    onBlockSelect(event) {
      if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
      const slide = event.target.closest('[data-fifth-slide]');
      if (!slide) return;
      this.setCurrent(Number(slide.dataset.fifthIndex));
    }
  }

  if (!customElements.get('electronic-badge-fifth-screen')) {
    customElements.define('electronic-badge-fifth-screen', ElectronicBadgeFifthScreen);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronic-badge-first-screen"] && !Shopify.designMode) return;
  try {
    
  class ElectronicBadgeSoundToggle extends HTMLElement {
    connectedCallback() {
      this.mediaSection = this.closest('.electronic-badge-media');
      this.button = this.querySelector('[data-electronic-badge-sound-button]');
      this.videos = Array.from(this.mediaSection?.querySelectorAll('video.electronic-badge-media__asset') || []);
      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.soundEnabled = false;

      this.onClick = () => {
        this.soundEnabled = !this.soundEnabled;
        this.applySound(true);
      };
      this.onBreakpointChange = () => {
        this.soundEnabled = false;
        this.videos.forEach((video) => {
          video.defaultMuted = true;
          video.muted = true;
        });
        this.applySound(false);
        this.syncPlayback();
      };

      this.videos.forEach((video) => {
        video.defaultMuted = true;
        video.muted = true;
      });
      this.button?.addEventListener('click', this.onClick);
      this.breakpoint.addEventListener('change', this.onBreakpointChange);
      this.videoStateHandlers = this.videos.map((video) => {
        const showVideo = () => video.classList.add('is-playing');
        const showPoster = () => video.classList.remove('is-playing');

        video.addEventListener('playing', showVideo);
        video.addEventListener('loadstart', showPoster);
        video.addEventListener('error', showPoster);

        if (!video.paused && video.readyState >= 2) {
          showVideo();
        }

        return { video, showVideo, showPoster };
      });
      this.applySound(false);
      this.syncPlayback();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.breakpoint?.removeEventListener('change', this.onBreakpointChange);
      this.videoStateHandlers?.forEach(({ video, showVideo, showPoster }) => {
        video.removeEventListener('playing', showVideo);
        video.removeEventListener('loadstart', showPoster);
        video.removeEventListener('error', showPoster);
      });
      this.videos?.forEach((video) => {
        video.muted = true;
      });
    }

    getActiveVideo() {
      return this.videos.find((video) => {
        const styles = window.getComputedStyle(video);
        return styles.display !== 'none' && styles.visibility !== 'hidden' && video.getClientRects().length > 0;
      });
    }

    syncPlayback() {
      const activeVideo = this.getActiveVideo();
      this.videos.forEach((video) => {
        if (video === activeVideo) {
          const playPromise = video.play();
          playPromise?.catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    applySound(userTriggered) {
      const activeVideo = this.getActiveVideo();
      this.hidden = !activeVideo;

      if (!activeVideo) {
        this.soundEnabled = false;
      }

      this.videos.forEach((video) => {
        video.muted = !this.soundEnabled || video !== activeVideo;
      });

      this.classList.toggle('is-sound-on', this.soundEnabled);
      this.button?.setAttribute('aria-label', this.soundEnabled ? 'Turn sound off' : 'Turn sound on');

      if (userTriggered && this.soundEnabled && activeVideo) {
        const playPromise = activeVideo.play();
        playPromise?.catch(() => {
          this.soundEnabled = false;
          activeVideo.muted = true;
          this.classList.remove('is-sound-on');
          this.button?.setAttribute('aria-label', 'Turn sound on');
        });
      }
    }
  }

  if (!customElements.get('electronic-badge-sound-toggle')) {
    customElements.define('electronic-badge-sound-toggle', ElectronicBadgeSoundToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronic-badge-fourth-screen"] && !Shopify.designMode) return;
  try {
    
  class ElectronicBadgeFourthScreen extends HTMLElement {
    connectedCallback() {
      if (this.dataset.fourthScreenReady === 'true') return;
      this.dataset.fourthScreenReady = 'true';
      this.classList.add('is-ready');

      const show = () => this.classList.add('is-visible');

      if (
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        typeof IntersectionObserver === 'undefined'
      ) {
        show();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer?.disconnect();
          show();
        },
        {
          threshold: 0,
          rootMargin: '-40% 0px -40% 0px'
        }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('electronic-badge-fourth-screen')) {
    customElements.define('electronic-badge-fourth-screen', ElectronicBadgeFourthScreen);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronic-badge-image-showcase"] && !Shopify.designMode) return;
  try {
    
  const initializeElectronicBadgeImageShowcase = (scope = document) => {
    const showcases = scope.matches?.('[data-image-showcase]')
      ? [scope]
      : scope.querySelectorAll?.('[data-image-showcase]') || [];

    showcases.forEach((showcase) => {
      if (showcase.dataset.animationInitialized === 'true') return;
      showcase.dataset.animationInitialized = 'true';

      const frames = [...showcase.querySelectorAll('.electronic-badge-image-showcase__frame')];
      if (!frames.length) return;

      frames.forEach((frame, index) => {
        frame.style.setProperty('--frame-entry-delay', `${Math.min(index * 110, 440)}ms`);
      });

      showcase.classList.add('is-animation-ready');

      if (!('IntersectionObserver' in window)) {
        frames.forEach((frame) => frame.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.12,
        }
      );

      frames.forEach((frame) => observer.observe(frame));
    });
  };

  initializeElectronicBadgeImageShowcase();

  document.addEventListener('shopify:section:load', (event) => {
    initializeElectronicBadgeImageShowcase(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronic-badge-second-screen"] && !Shopify.designMode) return;
  try {
    
  class ElectronicBadgeShowcase extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-showcase-item]'));
      this.badge = this.querySelector('[data-showcase-badge]');
      this.gallery = this.querySelector('.electronic-badge-showcase__gallery');
      this.track = this.querySelector('[data-badge-track]');
      this.ring = this.querySelector('[data-badge-ring]');
      this.swipeTarget = this.ring || this.badge;
      this.mobileSwipe = window.matchMedia('(max-width: 749px)');
      this.activeSwipeElement = null;
      this.ignoreClickUntil = 0;
      this.bubbles = Array.from(this.querySelectorAll('[data-showcase-bubble]'));
      this.currentIndex = 0;
      this.intervalDuration = Number(this.dataset.interval) || 4000;
      this.isVisible = false;
      this.hasRevealed = false;
      this.isPrepared = false;
      this.isHovered = false;
      this.editorPaused = false;
      this.isDragging = false;
      this.dragStartX = 0;
      this.dragStartY = 0;
      this.dragDeltaX = 0;
      this.dragAxis = null;
      this.pendingLoopReset = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      const bubbleSizes = [16, 48, 23, 76, 19];
      this.bubbles.forEach((bubble, index) => {
        const size = bubbleSizes[index % bubbleSizes.length] + Math.round(-2 + Math.random() * 4);
        bubble.style.setProperty('--bubble-size', `${size}px`);
        bubble.style.setProperty('--bubble-rotation', `${Math.round(-22 + Math.random() * 44)}deg`);
        bubble.style.setProperty('--bubble-delay', `${Math.round(100 + Math.random() * 500)}ms`);
        bubble.style.setProperty('--bubble-duration', `${Math.round(1450 + Math.random() * 550)}ms`);
        bubble.style.setProperty('--bubble-rise', `${Math.round(28 + Math.random() * 22)}px`);
      });

      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handlePointerEnter = this.handlePointerEnter.bind(this);
      this.handlePointerLeave = this.handlePointerLeave.bind(this);
      this.handleSwipeStart = this.handleSwipeStart.bind(this);
      this.handleSwipeMove = this.handleSwipeMove.bind(this);
      this.handleSwipeEnd = this.handleSwipeEnd.bind(this);
      this.handleSwipeCancel = this.handleSwipeCancel.bind(this);
      this.handleNativeDrag = this.handleNativeDrag.bind(this);
      this.handleTrackTransitionEnd = this.handleTrackTransitionEnd.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);

      this.items.forEach((item) => {
        item.addEventListener('click', (event) => {
          if (Date.now() < this.ignoreClickUntil) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }

          const targetIndex = Number(item.dataset.showcaseIndex);
          const direction = targetIndex >= this.currentIndex ? 1 : -1;
          this.activate(targetIndex, direction);
          this.restartAfterSwitch();
        });
      });

      this.track?.addEventListener('transitionend', this.handleTrackTransitionEnd);
      this.swipeTarget?.addEventListener('pointerdown', this.handleSwipeStart);
      this.swipeTarget?.addEventListener('pointermove', this.handleSwipeMove);
      this.swipeTarget?.addEventListener('pointerup', this.handleSwipeEnd);
      this.swipeTarget?.addEventListener('pointercancel', this.handleSwipeCancel);
      this.swipeTarget?.addEventListener('lostpointercapture', this.handleSwipeCancel);
      this.gallery?.addEventListener('pointerdown', this.handleSwipeStart);
      this.gallery?.addEventListener('pointermove', this.handleSwipeMove);
      this.gallery?.addEventListener('pointerup', this.handleSwipeEnd);
      this.gallery?.addEventListener('pointercancel', this.handleSwipeCancel);
      this.gallery?.addEventListener('lostpointercapture', this.handleSwipeCancel);
      this.badge?.addEventListener('dragstart', this.handleNativeDrag, true);
      this.addEventListener('pointerenter', this.handlePointerEnter);
      this.addEventListener('pointerleave', this.handlePointerLeave);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      this.activate(0);
      this.classList.add('is-ready');

      if (this.reduceMotion || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
        this.prepare();
        this.isVisible = true;
        this.hasRevealed = true;
        this.classList.add('is-visible');
        this.start();
        return;
      }

      this.prewarmObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.prepare();
            this.syncDesignMedia();
          } else if (this.isPrepared && !this.isVisible) {
            this.releaseDesignMedia();
          }
        },
        {
          threshold: 0,
          rootMargin: '200px 0px'
        }
      );
      this.prewarmObserver.observe(this);

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.isVisible = entry.isIntersecting;

          if (entry.isIntersecting && this.hasRevealed) {
            this.prepare();
            this.syncDesignMedia();
            this.start();
          } else {
            this.stop();
            if (!entry.isIntersecting && this.hasRevealed) this.releaseDesignMedia();
          }
        },
        { threshold: 0.01 }
      );
      this.observer.observe(this);

      this.revealObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;

          this.prepare();
          this.hasRevealed = true;
          this.classList.add('is-visible');
          this.revealObserver?.disconnect();
          if (this.isVisible) this.start();
        },
        {
          threshold: 0,
          rootMargin: '-40% 0px -40% 0px'
        }
      );
      this.revealObserver.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      this.revealObserver?.disconnect();
      this.prewarmObserver?.disconnect();
      this.track?.removeEventListener('transitionend', this.handleTrackTransitionEnd);
      this.swipeTarget?.removeEventListener('pointerdown', this.handleSwipeStart);
      this.swipeTarget?.removeEventListener('pointermove', this.handleSwipeMove);
      this.swipeTarget?.removeEventListener('pointerup', this.handleSwipeEnd);
      this.swipeTarget?.removeEventListener('pointercancel', this.handleSwipeCancel);
      this.swipeTarget?.removeEventListener('lostpointercapture', this.handleSwipeCancel);
      this.gallery?.removeEventListener('pointerdown', this.handleSwipeStart);
      this.gallery?.removeEventListener('pointermove', this.handleSwipeMove);
      this.gallery?.removeEventListener('pointerup', this.handleSwipeEnd);
      this.gallery?.removeEventListener('pointercancel', this.handleSwipeCancel);
      this.gallery?.removeEventListener('lostpointercapture', this.handleSwipeCancel);
      this.badge?.removeEventListener('dragstart', this.handleNativeDrag, true);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    mountTemplate(container, selector) {
      if (!container || container.querySelector(`${selector} + *`)) return;
      const template = container.querySelector(selector);
      if (!template) return;
      container.appendChild(template.content.cloneNode(true));
    }

    prepare() {
      if (this.isPrepared) return;
      this.isPrepared = true;

      if (this.dataset.bubbleImage) {
        this.style.setProperty('--showcase-bubble-image', `url("${this.dataset.bubbleImage}")`);
      }

      this.items.forEach((item) => {
        this.mountTemplate(item, '[data-showcase-panel-template]');
      });
      this.mountTemplate(this.badge, '[data-showcase-frame-template]');
      this.setupLoop();
      this.syncDesignMedia();
    }

    syncDesignMedia() {
      if (!this.track) return;
      const activeIndexes = new Set([
        this.currentIndex,
        (this.currentIndex + 1) % this.items.length,
        (this.currentIndex - 1 + this.items.length) % this.items.length
      ]);

      this.track.querySelectorAll('[data-showcase-slide-index]').forEach((slide) => {
        const slideIndex = Number(slide.dataset.showcaseSlideIndex);
        if (activeIndexes.has(slideIndex)) {
          if (!slide.querySelector('.electronic-badge-showcase__design')) {
            const template = slide.querySelector('[data-showcase-design-template]');
            if (template) slide.appendChild(template.content.cloneNode(true));
          }
        } else {
          slide.querySelector('.electronic-badge-showcase__design')?.remove();
        }
      });
    }

    releaseDesignMedia() {
      this.track?.querySelectorAll('.electronic-badge-showcase__design').forEach((image) => image.remove());
    }

    setupLoop() {
      if (!this.track || this.items.length < 2) return;

      this.track.querySelectorAll('[data-loop-clone]').forEach((clone) => clone.remove());
      const slides = Array.from(this.track.children);
      const firstClone = slides[0].cloneNode(true);
      const lastClone = slides[slides.length - 1].cloneNode(true);

      firstClone.dataset.loopClone = 'first';
      lastClone.dataset.loopClone = 'last';
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      this.track.prepend(lastClone);
      this.track.append(firstClone);
      this.track.classList.add('is-resetting');
      this.track.style.setProperty('--badge-track-x', '-100%');
      this.track.getBoundingClientRect();
      this.track.classList.remove('is-resetting');
    }

    activate(index, direction = 0) {
      if (!this.items.length) return;

      const previousIndex = this.currentIndex;
      this.currentIndex = (index + this.items.length) % this.items.length;
      let trackPosition = this.currentIndex + 1;
      this.pendingLoopReset = null;

      if (direction > 0 && previousIndex === this.items.length - 1 && this.currentIndex === 0) {
        trackPosition = this.items.length + 1;
        this.pendingLoopReset = 1;
      } else if (direction < 0 && previousIndex === 0 && this.currentIndex === this.items.length - 1) {
        trackPosition = 0;
        this.pendingLoopReset = this.items.length;
      }

      this.track?.classList.remove('is-resetting');
      if (this.isPrepared) this.syncDesignMedia();
      this.track?.style.setProperty('--badge-track-x', `${trackPosition * -100}%`);

      this.items.forEach((item) => {
        item.setAttribute('aria-pressed', String(Number(item.dataset.showcaseIndex) === this.currentIndex));
      });
    }

    handleTrackTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform' || this.pendingLoopReset === null) {
        return;
      }

      const resetPosition = this.pendingLoopReset;
      this.pendingLoopReset = null;
      this.track.classList.add('is-resetting');
      this.track.style.setProperty('--badge-track-x', `${resetPosition * -100}%`);
      this.track.getBoundingClientRect();
      this.track.classList.remove('is-resetting');
    }

    start() {
      if (
        !this.isPrepared ||
        this.items.length < 2 ||
        !this.isVisible ||
        this.isHovered ||
        this.editorPaused ||
        this.reduceMotion ||
        this.isDragging ||
        document.hidden ||
        this.timer
      ) {
        return;
      }

      this.timer = window.setTimeout(() => {
        this.timer = undefined;
        this.activate(this.currentIndex + 1, 1);
        this.restartAfterSwitch();
      }, this.intervalDuration);
    }

    stop() {
      window.clearTimeout(this.timer);
      window.clearTimeout(this.transitionTimer);
      this.timer = undefined;
      this.transitionTimer = undefined;
    }

    restart() {
      this.stop();
      this.start();
    }

    restartAfterSwitch() {
      this.stop();
      const transitionDuration = this.reduceMotion ? 0 : 520;

      this.transitionTimer = window.setTimeout(() => {
        this.transitionTimer = undefined;
        this.start();
      }, transitionDuration);
    }

    handlePointerEnter() {
      if (!this.canHover) return;
      this.isHovered = true;
      this.stop();
    }

    handlePointerLeave() {
      if (!this.canHover) return;
      this.isHovered = false;
      this.start();
    }

    handleSwipeStart(event) {
      if (this.items.length < 2 || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (event.currentTarget === this.gallery && !this.mobileSwipe.matches) return;

      if (event.pointerType === 'mouse' && event.cancelable) {
        event.preventDefault();
      }

      if (this.pendingLoopReset !== null && this.track) {
        this.pendingLoopReset = null;
        this.track.classList.add('is-resetting');
        this.track.style.setProperty('--badge-track-x', `${(this.currentIndex + 1) * -100}%`);
        this.track.getBoundingClientRect();
        this.track.classList.remove('is-resetting');
      }

      this.activeSwipeElement = event.currentTarget || this.swipeTarget;
      this.isDragging = true;
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      this.dragDeltaX = 0;
      this.dragAxis = null;
      this.stop();

      if (this.activeSwipeElement !== this.gallery) {
        this.badge.classList.add('is-dragging');
      }

      this.activeSwipeElement.setPointerCapture?.(event.pointerId);
    }

    handleSwipeMove(event) {
      if (!this.isDragging) return;

      const deltaX = event.clientX - this.dragStartX;
      const deltaY = event.clientY - this.dragStartY;

      if (this.dragAxis === null) {
        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 6) return;
        this.dragAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
      }

      if (this.dragAxis === 'vertical') {
        this.finishSwipe(event, true);
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      if (this.activeSwipeElement === this.gallery) {
        this.dragDeltaX = deltaX;
        return;
      }

      const dragLimit = this.badge.clientWidth;
      this.dragDeltaX = Math.max(-dragLimit, Math.min(dragLimit, deltaX));
      this.badge.style.setProperty('--badge-drag-x', `${this.dragDeltaX}px`);
    }

    handleSwipeEnd(event) {
      this.finishSwipe(event, false);
    }

    handleSwipeCancel(event) {
      this.finishSwipe(event, true);
    }

    finishSwipe(event, cancelled) {
      if (!this.isDragging) return;

      const swipeElement = this.activeSwipeElement || this.swipeTarget;
      const isBannerSwipe = swipeElement === this.gallery;
      const wasHorizontal = this.dragAxis === 'horizontal';
      const swipeWidth = swipeElement?.clientWidth || this.badge?.clientWidth || 0;
      const threshold = Math.max(32, swipeWidth * 0.16);
      const shouldSwitch = !cancelled && wasHorizontal && Math.abs(this.dragDeltaX) >= threshold;
      const direction = this.dragDeltaX < 0 ? 1 : -1;

      this.isDragging = false;
      this.dragAxis = null;

      if (!isBannerSwipe) {
        this.badge.classList.remove('is-dragging');
        this.badge.style.removeProperty('--badge-drag-x');
      }

      if (swipeElement?.hasPointerCapture?.(event.pointerId)) {
        swipeElement.releasePointerCapture(event.pointerId);
      }

      if (wasHorizontal && isBannerSwipe) {
        this.ignoreClickUntil = Date.now() + 400;
      }

      this.activeSwipeElement = null;

      if (shouldSwitch) {
        this.activate(this.currentIndex + direction, direction);
        this.restartAfterSwitch();
      } else {
        this.restart();
      }
    }

    handleNativeDrag(event) {
      event.preventDefault();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    }

    handleBlockSelect(event) {
      const item = event.target.closest('[data-showcase-item]');
      if (!item) return;

      this.editorPaused = true;
      this.stop();
      this.activate(Number(item.dataset.showcaseIndex));
    }

    handleBlockDeselect() {
      this.editorPaused = false;
      this.start();
    }
  }

  if (!customElements.get('electronic-badge-showcase')) {
    customElements.define('electronic-badge-showcase', ElectronicBadgeShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronic-badge-seventh-screen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '.electronic-badge-sixth-screen';

    function setup(section) {
      if (section.dataset.sixthScreenReady === 'true') return;
      section.dataset.sixthScreenReady = 'true';

      const title = section.querySelector('[data-sixth-screen-title]');
      const titleText = section.querySelector('[data-sixth-screen-title-text]');
      const scroller = section.querySelector('[data-sixth-screen-scroller]');
      const track = section.querySelector('[data-sixth-screen-track]');
      const scrollbar = section.querySelector('[data-sixth-screen-scrollbar]');
      const thumb = section.querySelector('[data-sixth-screen-scrollbar-thumb]');
      const interactionButtons = Array.from(section.querySelectorAll('[data-sixth-interaction]'));

      if (section.dataset.sixthCursorUrl) {
        section.style.setProperty('--sixth-screen-cursor', `url("${section.dataset.sixthCursorUrl}") 17 17, auto`);
      }
      section.classList.add('is-ready');

      let titleLayoutFrame = 0;
      const layoutTitle = function () {
        titleLayoutFrame = 0;
        if (!title || !titleText) return;

        const titleElement = titleText.parentElement;
        title.classList.remove('is-wrapped');
        titleElement.style.removeProperty('font-size');

        const baseStyles = window.getComputedStyle(titleElement);
        const baseFontSize = Number.parseFloat(baseStyles.fontSize);
        const baseLineHeight = Number.parseFloat(baseStyles.lineHeight);
        const range = document.createRange();
        range.selectNodeContents(titleText);

        let lineRects = Array.from(range.getClientRects()).filter(function (rect) {
          return rect.width > 0 && rect.height > 0;
        });

        if (lineRects.length > 1) {
          title.classList.add('is-wrapped');
          const maxHeight = baseLineHeight * 2;
          let adjustedFontSize = baseFontSize;
          let attempts = 0;
          titleElement.style.fontSize = `${adjustedFontSize}px`;

          while (
            titleText.getBoundingClientRect().height > maxHeight &&
            adjustedFontSize > 10 &&
            attempts < 40
          ) {
            adjustedFontSize -= 0.25;
            titleElement.style.fontSize = `${adjustedFontSize}px`;
            attempts += 1;
          }

          lineRects = Array.from(range.getClientRects()).filter(function (rect) {
            return rect.width > 0 && rect.height > 0;
          });
        }

        if (!lineRects.length) return;

        const titleRect = title.getBoundingClientRect();
        const firstLine = lineRects[0];
        const lastLine = lineRects[lineRects.length - 1];
        title.style.setProperty('--sixth-first-left', `${firstLine.left - titleRect.left}px`);
        title.style.setProperty('--sixth-first-top', `${firstLine.top - titleRect.top}px`);
        title.style.setProperty('--sixth-last-right', `${lastLine.right - titleRect.left}px`);
        title.style.setProperty('--sixth-last-bottom', `${lastLine.bottom - titleRect.top}px`);
      };

      const scheduleTitleLayout = function () {
        if (titleLayoutFrame) cancelAnimationFrame(titleLayoutFrame);
        titleLayoutFrame = requestAnimationFrame(layoutTitle);
      };

      if (title && titleText) {
        let observedWidth = section.clientWidth;
        if (typeof ResizeObserver !== 'undefined') {
          const titleResizeObserver = new ResizeObserver(function () {
            const nextWidth = section.clientWidth;
            if (Math.abs(nextWidth - observedWidth) < 1) return;
            observedWidth = nextWidth;
            scheduleTitleLayout();
          });
          titleResizeObserver.observe(section);
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(scheduleTitleLayout);
        }
        scheduleTitleLayout();
      }

      const mountInteractionImage = function (button) {
        if (button.dataset.sixthInteractionCursorUrl) {
          button.style.setProperty(
            '--sixth-interaction-cursor',
            `url("${button.dataset.sixthInteractionCursorUrl}") 17 17, auto`
          );
        }
        if (button.querySelector('.electronic-badge-sixth-screen__interaction-image')) return;
        const template = button.querySelector('[data-sixth-interaction-image-template]');
        if (template) button.appendChild(template.content.cloneNode(true));
      };

      interactionButtons.forEach(function (button) {
        const randomAnimationPhase = -(Math.random() * 3.2);
        button.style.setProperty('--sixth-interaction-rain-delay', `${randomAnimationPhase.toFixed(3)}s`);

        button.addEventListener('pointerenter', function () {
          mountInteractionImage(button);
        }, { once: true });
        button.addEventListener('focus', function () {
          mountInteractionImage(button);
        }, { once: true });
        button.addEventListener('click', function () {
          mountInteractionImage(button);
          const mountedImage = button.querySelector('.electronic-badge-sixth-screen__interaction-image');
          if (!mountedImage) {
            button.classList.remove('is-active');
            button.setAttribute('aria-pressed', 'false');
            return;
          }
          const isActive = button.classList.toggle('is-active');
          button.setAttribute('aria-pressed', String(isActive));
        });
      });

      if (scroller && track && scrollbar && thumb) {
        let updateFrame = 0;
        let isDragging = false;
        let dragStartX = 0;
        let dragStartScroll = 0;

        const updateScrollbar = function () {
          updateFrame = 0;
          const maxScroll = scroller.scrollWidth - scroller.clientWidth;
          const hasOverflow = maxScroll > 1;
          scrollbar.classList.toggle('is-hidden', !hasOverflow);
          track.classList.toggle('is-contained', !hasOverflow);

          if (!hasOverflow) {
            thumb.style.width = '100%';
            thumb.style.left = '0%';
            return;
          }

          const thumbWidth = Math.max(14, (scroller.clientWidth / scroller.scrollWidth) * 100);
          const progress = scroller.scrollLeft / maxScroll;
          thumb.style.width = `${thumbWidth}%`;
          thumb.style.left = `${progress * (100 - thumbWidth)}%`;
        };

        const scheduleScrollbarUpdate = function () {
          if (updateFrame) return;
          updateFrame = requestAnimationFrame(updateScrollbar);
        };

        scroller.addEventListener('scroll', scheduleScrollbarUpdate, { passive: true });
        scroller.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (event.target.closest('[data-sixth-interaction]')) return;
          isDragging = true;
          dragStartX = event.clientX;
          dragStartScroll = scroller.scrollLeft;
          scroller.classList.add('is-dragging');
          scroller.setPointerCapture(event.pointerId);
        });
        scroller.addEventListener('pointermove', function (event) {
          if (!isDragging) return;
          scroller.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
        });

        const stopDragging = function () {
          isDragging = false;
          scroller.classList.remove('is-dragging');
        };

        scroller.addEventListener('pointerup', stopDragging);
        scroller.addEventListener('lostpointercapture', stopDragging);

        if (typeof ResizeObserver !== 'undefined') {
          const resizeObserver = new ResizeObserver(scheduleScrollbarUpdate);
          resizeObserver.observe(scroller);
          resizeObserver.observe(track);
        }

        requestAnimationFrame(updateScrollbar);
      }

      const reveal = function () {
        layoutTitle();
        if (title) title.classList.add('is-in');
        section.classList.add('is-visible');
      };

      if (
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        typeof IntersectionObserver === 'undefined'
      ) {
        reveal();
        return;
      }

      const observer = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          reveal();
          observer.disconnect();
        },
        {
          threshold: 0,
          rootMargin: '-40% 0px -40% 0px'
        }
      );

      observer.observe(section);
    }

    function gate(section) {
      if (section.dataset.sixthScreenGateReady === 'true') return;
      section.dataset.sixthScreenGateReady = 'true';

      if (
        window.Shopify?.designMode ||
        typeof IntersectionObserver === 'undefined'
      ) {
        setup(section);
        return;
      }

      const preloadObserver = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          preloadObserver.disconnect();
          setup(section);
        },
        {
          threshold: 0,
          rootMargin: '200px 0px'
        }
      );
      preloadObserver.observe(section);
    }

    function init(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll(SECTION_SELECTOR).forEach(gate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronic-badge-sixth-screen"] && !Shopify.designMode) return;
  try {
    
  class ElectronicBadgePolaroidGallery extends HTMLElement {
    connectedCallback() {
      this.setupVideoPlayback();

      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        this.decorationObserver = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            this.decorationObserver.disconnect();
            this.decorationFrame = requestAnimationFrame(() => this.placeDecorations());
          },
          {
            rootMargin: '200px 0px',
            threshold: 0
          }
        );
        this.decorationObserver.observe(this);
      } else {
        this.decorationFrame = requestAnimationFrame(() => this.placeDecorations());
      }
    }

    disconnectedCallback() {
      this.decorationObserver?.disconnect();
      if (this.decorationFrame != null) cancelAnimationFrame(this.decorationFrame);

      this.sectionVisibilityObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.videoTrackObserver?.disconnect();
      if (this.videoRefreshFrame != null) cancelAnimationFrame(this.videoRefreshFrame);
      if (this.onDocumentVisibilityChange) {
        document.removeEventListener('visibilitychange', this.onDocumentVisibilityChange);
      }
      if (this.videoItems) {
        Array.from(this.videoItems.keys()).forEach((item) => this.unregisterVideoItem(item));
      }
    }

    setupVideoPlayback() {
      if (!this.querySelector('.electronic-badge-polaroid-gallery__item video')) return;

      this.videoViewport = this.querySelector('.electronic-badge-polaroid-gallery__viewport');
      this.videoTrack = this.querySelector('[data-product-loop-track]');
      this.videoItems = new Map();
      this.videoVisibility = new Map();
      this.isSectionVisible = !('IntersectionObserver' in window);
      this.onDocumentVisibilityChange = () => this.syncVideos();

      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!this.videoItems.has(entry.target)) return;
              this.videoVisibility.set(entry.target, entry.isIntersecting);
            });
            this.syncVideos();
          },
          {
            root: this.videoViewport || null,
            threshold: 0
          }
        );

        this.sectionVisibilityObserver = new IntersectionObserver(
          ([entry]) => {
            this.isSectionVisible = entry.isIntersecting;
            this.syncVideos();
          },
          { threshold: 0 }
        );
        this.sectionVisibilityObserver.observe(this);
      }

      this.refreshVideoItems();
      this.syncVideos();

      if (this.videoTrack && 'MutationObserver' in window) {
        this.videoTrackObserver = new MutationObserver(() => {
          if (this.videoRefreshFrame != null) cancelAnimationFrame(this.videoRefreshFrame);
          this.videoRefreshFrame = requestAnimationFrame(() => {
            this.videoRefreshFrame = null;
            this.refreshVideoItems();
            this.syncVideos();
          });
        });
        this.videoTrackObserver.observe(this.videoTrack, { childList: true });
      }

      document.addEventListener('visibilitychange', this.onDocumentVisibilityChange);
    }

    refreshVideoItems() {
      const currentItems = new Set(
        this.querySelectorAll('.electronic-badge-polaroid-gallery__item')
      );

      this.videoItems.forEach((entry, item) => {
        if (!currentItems.has(item)) this.unregisterVideoItem(item);
      });

      currentItems.forEach((item) => {
        if (this.videoItems.has(item)) return;
        const video = item.querySelector('video');
        if (video) this.registerVideoItem(item, video);
      });
    }

    registerVideoItem(item, video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;

      const showVideo = () => video.classList.add('is-playing');
      const showPoster = () => video.classList.remove('is-playing');

      video.addEventListener('playing', showVideo);
      video.addEventListener('error', showPoster);
      video.addEventListener('loadstart', showPoster);

      if (!video.paused && video.readyState >= 2) showVideo();

      this.videoItems.set(item, { video, showVideo, showPoster });
      this.videoVisibility.set(item, !this.videoObserver);
      this.videoObserver?.observe(item);
    }

    unregisterVideoItem(item) {
      const entry = this.videoItems?.get(item);
      if (!entry) return;

      entry.video.pause();
      entry.video.removeEventListener('playing', entry.showVideo);
      entry.video.removeEventListener('error', entry.showPoster);
      entry.video.removeEventListener('loadstart', entry.showPoster);
      this.videoObserver?.unobserve(item);
      this.videoVisibility?.delete(item);
      this.videoItems.delete(item);
    }

    syncVideos() {
      if (!this.videoItems?.size) return;
      const canPlay = this.isSectionVisible && !document.hidden;

      this.videoItems.forEach(({ video }, item) => {
        const itemVisible = this.videoVisibility.get(item) === true;

        if (canPlay && itemVisible) {
          if (video.paused) {
            video.muted = true;
            const playPromise = video.play();
            playPromise?.catch(() => {});
          }
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    shuffle(values) {
      for (let index = values.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [values[index], values[randomIndex]] = [values[randomIndex], values[index]];
      }

      return values;
    }

    placeDecorations() {
      this.decorationFrame = null;
      const source = this.querySelector('.electronic-badge-polaroid-gallery__decorations');
      const decorations = Array.from(source?.querySelectorAll('[data-eb-polaroid-decoration]') || []);
      const photos = Array.from(
        this.querySelectorAll(
          '.electronic-badge-polaroid-gallery__item:not([data-plg-clone]) .electronic-badge-polaroid-gallery__photo'
        )
      );

      if (!decorations.length || !photos.length) return;

      const photoIndexes = this.shuffle(photos.map((photo, index) => index));
      const decoratedPhotoCount = Math.min(
        decorations.length,
        photos.length,
        Math.max(1, Math.ceil(photos.length * 0.6))
      );
      const edges = this.shuffle(['top', 'bottom', 'left', 'right']);

      decorations.forEach((decoration, index) => {
        const size = 30 + Math.random() * 20;
        const along = 20 + Math.random() * 60;
        const photoIndex = photoIndexes[index % decoratedPhotoCount];
        const edge = edges[(index + Math.floor(index / decoratedPhotoCount)) % edges.length];

        decoration.style.setProperty('--eb-polaroid-decoration-size', `${size.toFixed(1)}px`);
        decoration.style.setProperty('--eb-polaroid-decoration-along', `${along.toFixed(1)}%`);
        decoration.style.setProperty('--eb-polaroid-decoration-rotation', `${(Math.random() * 50 - 25).toFixed(1)}deg`);
        decoration.dataset.decorationEdge = edge;
        photos[photoIndex].appendChild(decoration);
      });

      const gallery = this.querySelector('product-loop-gallery');
      if (typeof gallery?.setup === 'function') gallery.setup();
    }
  }

  if (!customElements.get('electronic-badge-polaroid-gallery')) {
    customElements.define('electronic-badge-polaroid-gallery', ElectronicBadgePolaroidGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronic-badge-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  class ElectronicBadgeBottomCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-electronic-badge-sticky-atc]');
      this.usesLegacyFirstScreen = this.dataset.legacyFirstScreen === 'true';
      this.firstScreen = this.usesLegacyFirstScreen
        ? document.querySelector('.electronic-badge-media')
        : null;
      this.hero = this.usesLegacyFirstScreen
        ? null
        : document.querySelector('seacore-product-hero');
      this.sourceButton = this.usesLegacyFirstScreen
        ? this.firstScreen?.querySelector('.electronic-badge-media__purchase-button')
        : this.hero?.querySelector('[data-seacore-hero-button]');
      this.visibilityTarget = this.usesLegacyFirstScreen ? this.firstScreen : this.sourceButton;
      this.media = this.querySelector('.electronic-badge-bottom-cart__media');
      this.imageTemplate = this.querySelector('[data-electronic-badge-sticky-image]');
      this.variantText = this.querySelector('.electronic-badge-bottom-cart__variant');
      this.currentPrice = this.querySelector('.electronic-badge-bottom-cart__current-price');
      this.comparePrice = this.querySelector('.electronic-badge-bottom-cart__compare-price');
      this.price = this.querySelector('.electronic-badge-bottom-cart__price');
      this.dialog = this.querySelector('[data-electronic-badge-option-dialog]');
      this.dialogOptions = this.querySelector('[data-electronic-badge-option-list]');
      this.dialogSubmit = this.querySelector('[data-electronic-badge-option-submit]');
      this.dialogClose = this.querySelector('[data-electronic-badge-option-close]');
      this.dialogPrice = this.querySelector('[data-electronic-badge-dialog-price]');
      this.dialogCurrentPrice = this.querySelector('[data-electronic-badge-dialog-current-price]');
      this.dialogComparePrice = this.querySelector('[data-electronic-badge-dialog-compare-price]');
      this.frame = null;
      this.resetTimer = null;
      this.isAdding = false;
      this.usesScrollFallback = false;

      this.onViewportChange = () => {
        if (this.frame != null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateVisibility();
        });
      };
      this.onClick = () => {
        if (this.usesLegacyFirstScreen) {
          this.addToCart();
        } else {
          this.openOptions();
        }
      };
      this.onOptionClick = (event) => this.selectOption(event);
      this.onDialogSubmit = () => this.addToCart();
      this.onDialogClose = () => this.closeOptions();
      this.onDialogBackdrop = (event) => {
        if (event.target === this.dialog) this.closeOptions();
      };
      this.onCartUpdate = () => this.finishAdding(true);
      this.onCartError = () => this.finishAdding(false);

      this.button?.addEventListener('click', this.onClick);
      this.dialogOptions?.addEventListener('click', this.onOptionClick);
      this.dialogSubmit?.addEventListener('click', this.onDialogSubmit);
      this.dialogClose?.addEventListener('click', this.onDialogClose);
      this.dialog?.addEventListener('click', this.onDialogBackdrop);
      document.addEventListener('cart:update', this.onCartUpdate);
      document.addEventListener('cart:error', this.onCartError);

      this.syncButton();

      if (this.visibilityTarget && 'IntersectionObserver' in window) {
        this.firstScreenObserver = new IntersectionObserver(([entry]) => {
          const shouldShow = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          this.setVisibility(shouldShow);
        });
        this.firstScreenObserver.observe(this.visibilityTarget);
      } else {
        this.usesScrollFallback = true;
        window.addEventListener('scroll', this.onViewportChange, { passive: true });
        window.addEventListener('resize', this.onViewportChange);
        this.updateVisibility();
      }
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.dialogOptions?.removeEventListener('click', this.onOptionClick);
      this.dialogSubmit?.removeEventListener('click', this.onDialogSubmit);
      this.dialogClose?.removeEventListener('click', this.onDialogClose);
      this.dialog?.removeEventListener('click', this.onDialogBackdrop);
      document.removeEventListener('cart:update', this.onCartUpdate);
      document.removeEventListener('cart:error', this.onCartError);
      this.firstScreenObserver?.disconnect();
      if (this.usesScrollFallback) {
        window.removeEventListener('scroll', this.onViewportChange);
        window.removeEventListener('resize', this.onViewportChange);
      }
      if (this.frame != null) cancelAnimationFrame(this.frame);
      if (this.resetTimer != null) clearTimeout(this.resetTimer);
    }

    mountImage() {
      if (!this.media || !this.imageTemplate || this.media.querySelector('img')) return;
      this.media.appendChild(this.imageTemplate.content.cloneNode(true));
    }

    setVisibility(shouldShow) {
      if (shouldShow) this.mountImage();
      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    updateVisibility() {
      if (!this.visibilityTarget) {
        if (this.usesLegacyFirstScreen) {
          this.firstScreen = document.querySelector('.electronic-badge-media');
          this.sourceButton = this.firstScreen?.querySelector(
            '.electronic-badge-media__purchase-button'
          );
          this.visibilityTarget = this.firstScreen;
        } else {
          this.hero = document.querySelector('seacore-product-hero');
          this.sourceButton = this.hero?.querySelector('[data-seacore-hero-button]');
          this.visibilityTarget = this.sourceButton;
        }
      }
      const shouldShow = Boolean(
        this.visibilityTarget && this.visibilityTarget.getBoundingClientRect().bottom <= 0
      );
      this.setVisibility(shouldShow);
    }

    syncButton() {
      if (!this.button) return;
      if (!this.sourceButton) {
        if (this.usesLegacyFirstScreen) {
          this.firstScreen = document.querySelector('.electronic-badge-media');
          this.sourceButton = this.firstScreen?.querySelector(
            '.electronic-badge-media__purchase-button'
          );
        } else {
          this.hero = document.querySelector('seacore-product-hero');
          this.sourceButton = this.hero?.querySelector('[data-seacore-hero-button]');
        }
      }

      if (this.usesLegacyFirstScreen) {
        const unavailable = !this.sourceButton || this.sourceButton.disabled;
        this.button.disabled = unavailable;
        this.button.textContent = unavailable ? this.dataset.soldOutLabel : this.dataset.addLabel;
        return;
      }

      this.button.disabled = !this.sourceButton;
      this.button.textContent = this.sourceButton
        ? this.dataset.addLabel
        : this.dataset.unavailableLabel;

      if (this.dialogSubmit) {
        const unavailable = !this.sourceButton || this.sourceButton.disabled;
        this.dialogSubmit.disabled = unavailable || this.isAdding;
        this.dialogSubmit.textContent = unavailable
          ? this.dataset.soldOutLabel
          : this.dataset.addLabel;
      }
    }

    openOptions() {
      if (!this.dialog || !this.sourceButton) return;
      this.renderOptions();

      if (typeof this.dialog.showModal === 'function') {
        if (!this.dialog.open) this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    closeOptions() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function' && this.dialog.open) {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
    }

    renderOptions() {
      if (!this.dialogOptions || !this.hero) return;
      const sourceOptions = this.hero.querySelector('[data-seacore-hero-options]');
      if (!sourceOptions) return;

      const clone = sourceOptions.cloneNode(true);
      clone.querySelectorAll('[id]').forEach((element, index) => {
        const id = `ElectronicBadgeOption-${index}-${Date.now()}`;
        const oldId = element.id;
        element.id = id;
        clone.querySelectorAll(`[aria-labelledby="${oldId}"]`).forEach((labelledElement) => {
          labelledElement.setAttribute('aria-labelledby', id);
        });
      });
      this.dialogOptions.replaceChildren(clone);
      this.syncFromHero();
    }

    selectOption(event) {
      const dialogButton = event.target.closest?.('[data-seacore-hero-option-value]');
      if (!dialogButton || dialogButton.disabled || !this.hero) return;

      const position = dialogButton.dataset.optionPosition;
      const value = dialogButton.dataset.optionValue;
      const sourceOption = Array.from(
        this.hero.querySelectorAll('[data-seacore-hero-option-value]')
      ).find(
        (button) =>
          button.dataset.optionPosition === position &&
          button.dataset.optionValue === value
      );

      if (!sourceOption) return;
      sourceOption.click();
      requestAnimationFrame(() => this.renderOptions());
    }

    syncFromHero() {
      if (!this.hero) return;

      const selectedValues = Array.from(
        this.hero.querySelectorAll('[data-seacore-hero-option-value].is-selected')
      ).map((button) => button.dataset.optionLabel || button.textContent.trim());

      if (this.variantText) {
        this.variantText.textContent = selectedValues.join(' / ');
        this.variantText.hidden = selectedValues.length === 0;
      }

      const variant = this.hero.currentVariant;
      if (variant?.price && this.currentPrice) {
        this.currentPrice.textContent = variant.price;
        this.comparePrice?.setAttribute('hidden', '');
        this.price?.classList.remove('is-sale');
      }
      if (variant?.price && this.dialogCurrentPrice) {
        this.dialogCurrentPrice.textContent = variant.price;
        this.dialogPrice?.classList.toggle('is-sale', Boolean(variant.on_sale));
        if (variant.on_sale && variant.compare_at_price) {
          this.dialogComparePrice.textContent = variant.compare_at_price;
          this.dialogComparePrice.removeAttribute('hidden');
        } else {
          this.dialogComparePrice?.setAttribute('hidden', '');
        }
      }

      this.mountImage();
      const sourceImage = this.hero.querySelector('img.seacore-product-hero__main-image');
      const stickyImage = this.media?.querySelector('img');
      if (sourceImage && stickyImage) {
        stickyImage.src = sourceImage.currentSrc || sourceImage.src;
        stickyImage.alt = sourceImage.alt || '';
      }

      this.syncButton();
    }

    addToCart() {
      if (!this.sourceButton || this.sourceButton.disabled || this.isAdding) return;
      this.isAdding = true;
      if (this.usesLegacyFirstScreen && this.button) {
        this.button.disabled = true;
        this.button.textContent = this.dataset.addingLabel;
      } else if (this.dialogSubmit) {
        this.dialogSubmit.disabled = true;
        this.dialogSubmit.textContent = this.dataset.addingLabel;
      }

      if (!this.usesLegacyFirstScreen) this.closeOptions();
      this.sourceButton.dataset.puppet = 'true';
      this.sourceButton.click();
      delete this.sourceButton.dataset.puppet;

      if (this.resetTimer != null) clearTimeout(this.resetTimer);
      this.resetTimer = window.setTimeout(() => this.finishAdding(false), 5000);
    }

    finishAdding(success) {
      if (!this.isAdding) return;
      this.isAdding = false;
      if (this.resetTimer != null) clearTimeout(this.resetTimer);
      this.resetTimer = null;

      if (this.usesLegacyFirstScreen && this.button) {
        if (success) {
          this.button.textContent = this.dataset.addedLabel;
          this.resetTimer = window.setTimeout(() => {
            this.resetTimer = null;
            this.syncButton();
          }, 900);
        } else {
          this.syncButton();
        }
      } else if (success && this.dialogSubmit) {
        this.dialogSubmit.textContent = this.dataset.addedLabel;
        this.resetTimer = window.setTimeout(() => {
          this.resetTimer = null;
          this.syncButton();
        }, 900);
      } else {
        this.syncButton();
      }
    }
  }

  if (!customElements.get('electronic-badge-bottom-cart')) {
    customElements.define('electronic-badge-bottom-cart', ElectronicBadgeBottomCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronic-badge-third-screen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '.electronic-badge-stick-shoot';
    const TARGET_SELECTOR = '[data-eb-reveal]';
    const STAGGER = 120;
    const STAR_STAGGER = 200;

    function setup(section) {
      if (section.dataset.ebRevealReady === 'true') return;
      section.dataset.ebRevealReady = 'true';

      const targets = section.querySelectorAll(TARGET_SELECTOR);
      if (!targets.length) return;

      section.classList.add('is-ready');

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const decorations = Array.from(
        section.querySelectorAll('.electronic-badge-stick-shoot__deco')
      );
      const orderedTargets = Array.from(targets).filter(function (target) {
        return !target.classList.contains('electronic-badge-stick-shoot__deco');
      });

      if (reduceMotion || typeof IntersectionObserver === 'undefined') {
        targets.forEach(function (target) {
          target.classList.add('is-in');
        });
        return;
      }

      const revealAll = function () {
        orderedTargets.forEach(function (target, index) {
          target.style.setProperty('--reveal-delay', index * STAGGER + 'ms');
          target.classList.add('is-in');
        });

        const randomDecorations = decorations.slice();
        for (let index = randomDecorations.length - 1; index > 0; index -= 1) {
          const randomIndex = Math.floor(Math.random() * (index + 1));
          const current = randomDecorations[index];
          randomDecorations[index] = randomDecorations[randomIndex];
          randomDecorations[randomIndex] = current;
        }

        randomDecorations.forEach(function (decoration, index) {
          decoration.style.setProperty('--reveal-delay', index * STAR_STAGGER + 'ms');
          decoration.classList.add('is-in');
        });
      };

      const observer = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          observer.disconnect();
          requestAnimationFrame(revealAll);
        },
        {
          threshold: 0,
          rootMargin: '-40% 0px -40% 0px'
        }
      );

      observer.observe(section);
    }

    function init(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll(SECTION_SELECTOR).forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-iphonecase"]) return;
  try {
    
  (function () {
    const url = new URL(window.location.href);
    if (url.hash) {
      const scrollToProduct = () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scrollToProduct, { once: true });
      } else {
        scrollToProduct();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-iphonemodel"]) return;
  try {
    
  (function () {
    const url = new URL(window.location.href);
    if (!url.hash) return;

    function scrollToHash() {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        scrollToHash,
        { once: true }
      );
    } else {
      scrollToHash();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-case-information"] && !Shopify.designMode) return;
  try {
    
  class PiTabs extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const signal = this.#controller.signal;

      this.tabs = Array.from(this.querySelectorAll('[data-pi-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-pi-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener(
          'click',
          () => {
            if (!this.locked) this.activate(tab.dataset.piTab);
          },
          { signal }
        );
        tab.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      });

      document.addEventListener(
        'pi:bundle-busy-changed',
        (event) => {
          if (!event.detail?.source || !this.contains(event.detail.source)) return;
          this.locked = Boolean(event.detail.busy);
        },
        { signal }
      );

      const initialTab =
        this.tabs.find((tab) => tab.classList.contains('is-active') && !tab.hidden) ||
        this.tabs.find((tab) => !tab.hidden);
      if (initialTab) this.activate(initialTab.dataset.piTab);
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    handleKeydown(event) {
      if (this.locked) return;
      const availableTabs = this.tabs.filter((tab) => !tab.hidden && !tab.disabled);
      const currentIndex = availableTabs.indexOf(event.currentTarget);
      if (currentIndex < 0) return;

      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % availableTabs.length;
      if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + availableTabs.length) % availableTabs.length;
      }
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = availableTabs.length - 1;
      if (nextIndex == null) return;

      event.preventDefault();
      const nextTab = availableTabs[nextIndex];
      this.activate(nextTab.dataset.piTab, { focus: true });
    }

    activate(index, options = {}) {
      const targetTab = this.tabs.find(
        (tab) => tab.dataset.piTab === index && !tab.hidden && !tab.disabled
      );
      if (!targetTab) return;

      this.tabs.forEach((tab) => {
        const active = tab === targetTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.piPanel === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      const accessories = this.closest('.product-block--2')?.querySelector(
        '[data-pi-product-accessories]'
      );
      if (accessories) accessories.hidden = index === 'bundle';

      if (options.focus) targetTab.focus();
      document.dispatchEvent(
        new CustomEvent('pi:tab-changed', {
          detail: {
            tab: index,
            tabs: this,
          },
        })
      );
    }
  }

  if (!customElements.get('pi-tabs')) {
    customElements.define('pi-tabs', PiTabs);
  }

  const renderPiPrice = (container, variant) => {
    if (!container) return;

    const currentPrice = container.querySelector('[data-pi-price-current]');
    const comparePrice = container.querySelector('[data-pi-price-compare]');
    const price = variant && variant.price ? variant.price : '';
    const compareAtPrice = variant && variant.compare_at_price ? variant.compare_at_price : '';

    if (currentPrice) {
      currentPrice.textContent = price;
    } else {
      container.textContent = price;
    }

    if (comparePrice) {
      comparePrice.textContent = compareAtPrice;
      comparePrice.hidden = !compareAtPrice;
    }
  };

  class PiVariant extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const signal = this.#controller.signal;

      const dataEl = this.querySelector('[data-pi-variants]');
      try {
        const variantData = dataEl ? JSON.parse(dataEl.textContent) : [];
        this.variants = Array.isArray(variantData)
          ? variantData.map((variant) => {
              if (!Array.isArray(variant)) return variant;
              const [id, options, available, price, media, image, phoneModel, compareAtPrice] = variant;
              return {
                id,
                options,
                available,
                price,
                media,
                image,
                phone_model: phoneModel,
                compare_at_price: compareAtPrice,
              };
            })
          : [];
      } catch (e) {
        this.variants = [];
      }
      this.priceEl = this.querySelector('[data-pi-price]');
      this.idInput = this.querySelector('[data-pi-variant-id]');
      this.atc = this.querySelector('[data-pi-atc]');
      this.atcText = this.querySelector('[data-pi-atc-text]');
      this.atcPrice = this.querySelector('[data-pi-atc-price]');
      this.atcSeparator = this.querySelector('[data-pi-atc-separator]');
      this.form = this.querySelector('[data-pi-atc-form]');
      this.atcError = this.querySelector('[data-pi-atc-error]');

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleAddToCart(event), { signal });
      }

      this.addEventListener('click', (event) => {
        // 按钮组 / 卡片组
        const btn = event.target.closest('.pi2-variant__value, .pi2-card');
        if (btn && this.contains(btn)) {
          const cont = btn.closest('[data-pi-opt]');
          if (cont) {
            cont.querySelectorAll('.pi2-variant__value, .pi2-card').forEach((b) => {
              b.classList.toggle('is-active', b === btn);
            });
            this.update();
          }
          return;
        }
        // 抽屉项
        const item = event.target.closest('.pi2-drawer__item');
        if (item && this.contains(item)) {
          const opt = item.closest('[data-pi-opt]');
          if (opt) {
            opt.dataset.piCurrent = item.dataset.piValue;
            const label = opt.querySelector('[data-pi-opt-label]');
            if (label) label.textContent = item.dataset.piValue;
            opt.querySelectorAll('.pi2-drawer__item').forEach((i) => {
              i.classList.toggle('is-selected', i === item);
            });
            const dlg = item.closest('dialog');
            if (dlg && typeof dlg.close === 'function') dlg.close();
            this.update();
          }
        }
      }, { signal });

      // 通用 variant 抽屉内搜索过滤；Case 型号导航使用独立组件。
      this.querySelectorAll('.pi2-drawer__search').forEach((input) => {
        input.addEventListener('input', () => {
          const q = input.value.trim().toLowerCase();
          const scope = input.closest('.pi2-opt') || this;
          scope.querySelectorAll('.pi2-drawer__item').forEach((it) => {
            const hit = (it.dataset.piValue || '').toLowerCase().indexOf(q) !== -1;
            it.style.display = hit ? '' : 'none';
          });
          scope.querySelectorAll('.pi2-drawer__group').forEach((g) => {
            const items = Array.from(g.querySelectorAll('.pi2-drawer__item'));
            const anyVisible = items.some((it) => it.style.display !== 'none');
            g.style.display = anyVisible ? '' : 'none';
          });
        }, { signal });
      });

      // 原生 variant 深链优先；兼容旧的 type 参数。
      this.applyUrlSelection();
      this.update();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    normalizeOptionValue(value) {
      return String(value || '').trim().toLowerCase();
    }

    getUrlParam(name) {
      try {
        return new URL(window.location.href).searchParams.get(name) || '';
      } catch (e) {
        return '';
      }
    }

    findMatchingElement(elements, value, getValue) {
      const target = this.normalizeOptionValue(value);
      if (!target) return null;

      return Array.from(elements).find((el) => this.normalizeOptionValue(getValue(el)) === target) || null;
    }

    findVariantById(variantId) {
      const normalizedId = String(variantId || '').trim();
      if (!normalizedId) return null;

      return this.variants.find((variant) => String(variant && variant.id) === normalizedId) || null;
    }

    applyVariantSelection(variant) {
      if (!variant || !Array.isArray(variant.options)) return;

      this.querySelectorAll('[data-pi-opt]').forEach((opt) => {
        const position = parseInt(opt.dataset.piOpt, 10) - 1;
        const value = variant.options[position];
        if (Number.isNaN(position) || value == null) return;

        opt.dataset.piCurrent = value;

        opt.querySelectorAll('.pi2-variant__value, .pi2-card').forEach((candidate) => {
          candidate.classList.toggle(
            'is-active',
            this.normalizeOptionValue(candidate.dataset.piValue) === this.normalizeOptionValue(value)
          );
        });

        const drawerItem = this.findMatchingElement(
          opt.querySelectorAll('.pi2-drawer__item'),
          value,
          (el) => el.dataset.piValue
        );
        opt.querySelectorAll('.pi2-drawer__item').forEach((candidate) => {
          candidate.classList.toggle('is-selected', candidate === drawerItem);
        });

        opt.querySelectorAll('.footer-rm__select-label, [data-pi-opt-label]').forEach((label) => {
          label.textContent = value;
        });
      });
    }

    applyUrlSelection() {
      const nativeVariant = this.findVariantById(this.getUrlParam('variant'));
      if (nativeVariant) {
        this.applyVariantSelection(nativeVariant);
        return true;
      }

      // Backward compatibility for the old type parameter.
      this.applyUrlType(this.getUrlParam('type'));
      return false;
    }

    applyUrlType(typeName) {
      const normalizedType = String(typeName || '').trim();
      if (!normalizedType) return;

      const card = this.findMatchingElement(
        this.querySelectorAll('.pi2-cards .pi2-card'),
        normalizedType,
        (el) => el.dataset.piValue
      );

      if (card) {
        const opt = card.closest('[data-pi-opt]');
        if (!opt) return;

        opt.querySelectorAll('.pi2-card').forEach((candidate) => {
          candidate.classList.toggle('is-active', candidate === card);
        });
        return;
      }

      const item = this.findMatchingElement(
        this.querySelectorAll('[data-pi-opt] .pi2-drawer__item'),
        normalizedType,
        (el) => el.dataset.piValue
      );
      if (!item) return;

      const opt = item.closest('[data-pi-opt]');
      if (!opt) return;

      opt.dataset.piCurrent = item.dataset.piValue;
      const label = opt.querySelector('[data-pi-opt-label]');
      if (label) label.textContent = item.dataset.piValue;
      opt.querySelectorAll('.pi2-drawer__item').forEach((candidate) => {
        candidate.classList.toggle('is-selected', candidate === item);
      });
    }

    // 各 option 当前选中值，顺序 = options_with_values 顺序 = variant.options 顺序
    getSelected() {
      const opts = Array.from(this.querySelectorAll('[data-pi-opt]'));
      return opts.map((o) => {
        // 按钮组 / 卡片组
        const active = o.querySelector('.pi2-variant__value.is-active, .pi2-card.is-active');
        if (active) return active.dataset.piValue;
        const first = o.querySelector('.pi2-variant__value, .pi2-card');
        if (first) return first.dataset.piValue;
        // 抽屉控件
        return o.dataset.piCurrent || null;
      });
    }

    // 卡片组：按“当前其它 option + 该卡片值”算出对应 variant，刷新每张卡片的价格与可用态
    updateCardPrices() {
      const cards = this.querySelectorAll('.pi2-card');
      if (!cards.length) return;
      const selected = this.getSelected();
      cards.forEach((card) => {
        const cont = card.closest('[data-pi-opt]');
        if (!cont) return;
        const pos = parseInt(cont.dataset.piOpt, 10) - 1;
        const combo = selected.slice();
        combo[pos] = card.dataset.piValue;
        const v = this.findVariant(combo);
        const priceEl = card.querySelector('[data-pi-card-price]');
        renderPiPrice(priceEl, v);
        card.classList.toggle('is-unavailable', !(v && v.available));
      });
    }

    findVariant(selected) {
      return this.variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === selected.length &&
          v.options.every(
            (o, i) => this.normalizeOptionValue(o) === this.normalizeOptionValue(selected[i])
          )
      );
    }

    updateProductLinks() {
      const links = this.querySelectorAll('.pi2-more-designs__thumb, .pi-love__link');
      links.forEach((link) => {
        if (!link.href) return;

        try {
          const url = new URL(link.href, window.location.origin);
          if (url.pathname.indexOf('/products/') === -1) return;

          const cleanParams = new URLSearchParams();
          const variantId = url.searchParams.get('variant');
          if (variantId) cleanParams.set('variant', variantId);

          const cleanSearch = cleanParams.toString();
          link.setAttribute('href', `${url.pathname}${cleanSearch ? `?${cleanSearch}` : ''}${url.hash}`);
        } catch (e) {
          /* Ignore malformed URLs */
        }
      });
    }

    async handleAddToCart(event) {
      event.preventDefault();
      if (!this.form || !this.idInput || !this.atc || this.atc.disabled) return;

      const variantId = String(this.idInput.value || '').trim();
      if (!variantId) {
        this.showAddToCartError('Please select an available option.');
        return;
      }

      const quantityInput = this.form.querySelector('input[name="quantity"]');
      const quantity = Number(quantityInput && quantityInput.value) || 1;
      const previousText = this.atcText ? this.atcText.textContent : '';

      this.clearAddToCartError();
      this.atc.disabled = true;
      if (this.atcText) this.atcText.textContent = 'ADDING...';

      document.dispatchEvent(new CustomEvent('cart:open-checkout-drawer'));

      try {
        const formData = new FormData(this.form);
        formData.set('id', variantId);
        formData.set('quantity', String(quantity));

        const cartSectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((item) => item.dataset.sectionId)
          .filter(Boolean);
        if (cartSectionIds.length > 0) {
          formData.set('sections', cartSectionIds.join(','));
        }

        const response = await fetch(
          (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js',
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: formData,
          }
        );
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this item to cart.');
        }

        if (this.atcText) this.atcText.textContent = 'ADDED';
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'pi-variant',
              data: {
                source: 'product-form-component',
                itemCount: quantity,
                productId: this.form.dataset.piProductId,
                variantId,
                sections: data.sections,
              },
            },
          })
        );

        window.setTimeout(() => this.update(), 1200);
      } catch (error) {
        this.showAddToCartError(error && error.message ? error.message : 'Unable to add this item to cart.');
        if (this.atcText) this.atcText.textContent = previousText || 'ADD TO CART';
        this.atc.disabled = false;
      }
    }

    showAddToCartError(message) {
      if (!this.atcError) return;
      this.atcError.textContent = message;
      this.atcError.hidden = false;
    }

    clearAddToCartError() {
      if (!this.atcError) return;
      this.atcError.textContent = '';
      this.atcError.hidden = true;
    }

    isThemeEditorPreview() {
      return !!(
        (window.Shopify && window.Shopify.designMode) ||
        document.documentElement.classList.contains('shopify-design-mode')
      );
    }

    update() {
      const selected = this.getSelected();
      // 单变体产品没有 option 组：直接取第一个 variant
      const variant = selected.length ? this.findVariant(selected) : this.variants[0];

      // 卡片组价格随当前组合刷新
      this.updateCardPrices();

      if (variant) {
        this.clearAddToCartError();
        renderPiPrice(this.priceEl, variant);
        if (this.idInput) this.idInput.value = variant.id;
        if (this.atc) this.atc.disabled = !variant.available;
        if (this.atcText) this.atcText.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
        if (this.atcPrice) {
          renderPiPrice(this.atcPrice, variant);
          this.atcPrice.hidden = !variant.available;
        }
        if (this.atcSeparator) this.atcSeparator.hidden = !variant.available;

        if (!this.isThemeEditorPreview()) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('model');
          currentUrl.searchParams.delete('type');
          currentUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
        }
        this.updateProductLinks();

        document.dispatchEvent(
          new CustomEvent('pi:variant-changed', {
            detail: {
              variant,
              productId: this.form && this.form.dataset.piProductId,
            },
          })
        );
      } else {
        // 该属性组合不存在对应 variant
        if (this.atc) this.atc.disabled = true;
        if (this.atcText) this.atcText.textContent = 'UNAVAILABLE';
        if (this.atcPrice) this.atcPrice.hidden = true;
        if (this.atcSeparator) this.atcSeparator.hidden = true;
        document.dispatchEvent(
          new CustomEvent('pi:variant-changed', {
            detail: {
              variant: null,
              options: selected,
              productId: this.form && this.form.dataset.piProductId,
            },
          })
        );
      }
    }
  }

  if (!customElements.get('pi-variant')) {
    customElements.define('pi-variant', PiVariant);
  }

  class PiStickyCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-pi-sticky-atc]');
      this.nameEl = this.querySelector('[data-pi-sticky-name]');
      this.selectedEl = this.querySelector('[data-pi-sticky-selected]');
      this.priceEl = this.querySelector('[data-pi-sticky-price]');
      this.imageEl = this.querySelector('.pi-sticky-cart__image');
      this.productTitle = this.dataset.piStickyProductTitle || '';
      this.currentAvailable = this.button ? !this.button.disabled : true;
      this.mode = 'product';
      this.bundleState = null;
      this.currentVariant = null;
      this.productSnapshot = {
        name: this.nameEl?.textContent || this.productTitle,
        selected: this.selectedEl?.textContent || '',
        selectedHidden: this.selectedEl?.hidden ?? true,
        price: this.priceEl?.querySelector('[data-pi-price-current]')?.textContent || '',
        comparePrice: this.priceEl?.querySelector('[data-pi-price-compare]')?.textContent || '',
        image: this.imageEl?.currentSrc || this.imageEl?.src || '',
        available: this.currentAvailable,
      };

      this.handleScroll = () => this.updateVisibility();
      this.handleVariantChange = (event) => {
        this.currentVariant = event.detail && event.detail.variant;
        if (this.mode === 'product') this.renderProductMode();
      };
      this.handleSourceMutation = () => this.syncButtonFromSource();
      this.handleClick = () => this.addFromActiveSource();
      this.handleTabChange = (event) => this.updateMode(event);
      this.handleBundleState = (event) => {
        this.bundleState = event.detail || null;
        if (this.mode === 'bundle') this.renderBundleMode();
      };

      if (this.button) this.button.addEventListener('click', this.handleClick);
      document.addEventListener('pi:variant-changed', this.handleVariantChange);
      document.addEventListener('pi:tab-changed', this.handleTabChange);
      document.addEventListener('pi:bundle-state-changed', this.handleBundleState);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);

      this.bindSourceButtons();
      this.updateVisibility();
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.handleClick);
      document.removeEventListener('pi:variant-changed', this.handleVariantChange);
      document.removeEventListener('pi:tab-changed', this.handleTabChange);
      document.removeEventListener('pi:bundle-state-changed', this.handleBundleState);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      this.sourceObservers?.forEach((observer) => observer.disconnect());
    }

    bindSourceButtons() {
      this.productButton = document.querySelector('.product-block--2 [data-pi-atc]');
      this.bundleButton = document.querySelector('.product-block--2 [data-pib-add]');
      this.triggerEl =
        document.querySelector('.product-block--2 .pi2-tabs__nav') ||
        this.productButton;
      if (!('MutationObserver' in window)) return;

      this.sourceObservers?.forEach((observer) => observer.disconnect());
      this.sourceObservers = [this.productButton, this.bundleButton].filter(Boolean).map((source) => {
        const observer = new MutationObserver(this.handleSourceMutation);
        observer.observe(source, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        });
        return observer;
      });
      this.syncButtonFromSource();
    }

    updateVisibility() {
      if (!this.productButton || !this.triggerEl) this.bindSourceButtons();
      if (!this.triggerEl) return;

      const triggerRect = this.triggerEl.getBoundingClientRect();
      const shouldShow = triggerRect.bottom <= 0;
      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    updateMode(event) {
      const tabs = event.detail?.tabs;
      if (!tabs?.closest('.product-block--2')) return;

      this.mode = event.detail.tab === 'bundle' ? 'bundle' : 'product';
      if (this.mode === 'bundle') {
        this.renderBundleMode();
      } else {
        this.renderProductMode();
      }
    }

    renderProductMode() {
      const variant = this.currentVariant;
      if (!variant) {
        this.currentAvailable = this.productSnapshot.available;
        if (this.nameEl) this.nameEl.textContent = this.productSnapshot.name;
        if (this.selectedEl) {
          this.selectedEl.textContent = this.productSnapshot.selected;
          this.selectedEl.hidden = this.productSnapshot.selectedHidden;
        }
        renderPiPrice(this.priceEl, {
          price: this.productSnapshot.price,
          compare_at_price: this.productSnapshot.comparePrice,
        });
        if (this.imageEl && this.productSnapshot.image) this.imageEl.src = this.productSnapshot.image;
        this.syncButtonFromSource();
        return;
      }

      this.currentAvailable = Boolean(variant.available);
      if (this.nameEl) {
        const phoneModel = String(variant.phone_model || '').trim();
        this.nameEl.textContent = phoneModel ? `${this.productTitle} - ${phoneModel} Case` : this.productTitle;
      }
      if (this.selectedEl && Array.isArray(variant.options)) {
        const phoneModel = String(variant.phone_model || '').trim();
        const selectedText = variant.options
          .filter(Boolean)
          .filter((option) => String(option).trim() !== phoneModel)
          .join(' / ');
        this.selectedEl.textContent = selectedText;
        this.selectedEl.hidden = selectedText === '';
      }
      renderPiPrice(this.priceEl, variant);
      if (this.imageEl && variant.image) {
        this.imageEl.removeAttribute('srcset');
        this.imageEl.src = variant.image;
      }
      this.syncButtonFromSource();
    }

    renderBundleMode() {
      const state = this.bundleState;
      if (!state) {
        if (this.nameEl) this.nameEl.textContent = 'Bundle & save';
        if (this.selectedEl) {
          this.selectedEl.textContent = 'Loading bundle options…';
          this.selectedEl.hidden = false;
        }
        if (this.button) {
          this.button.textContent = 'LOADING…';
          this.button.disabled = true;
        }
        return;
      }

      if (this.nameEl) this.nameEl.textContent = state.title || 'Bundle & save';
      if (this.selectedEl) {
        this.selectedEl.textContent = state.subtitle || '';
        this.selectedEl.hidden = !state.subtitle;
      }
      renderPiPrice(this.priceEl, {
        price: state.price || '',
        compare_at_price: state.comparePrice || '',
      });
      if (this.imageEl && state.image) {
        this.imageEl.removeAttribute('srcset');
        this.imageEl.src = state.image;
      }
      if (this.button) {
        this.button.textContent = state.buttonText || 'ADD BUNDLE';
        this.button.disabled = state.available === false;
      }
    }

    syncButtonFromSource() {
      if (!this.button) return;

      if (this.mode === 'bundle') {
        this.renderBundleMode();
        return;
      }

      const sourceText = this.productButton
        ? (this.productButton.querySelector('[data-pi-atc-text]') || this.productButton).textContent.trim()
        : '';

      if (sourceText === 'ADDING...' || sourceText === 'ADDED') {
        this.button.textContent = sourceText;
        this.button.disabled = true;
        return;
      }

      if (sourceText === 'SOLD OUT' || sourceText === 'UNAVAILABLE' || !this.currentAvailable) {
        this.button.textContent = sourceText || 'SOLD OUT';
        this.button.disabled = true;
        return;
      }

      this.button.textContent = 'ADD TO CART';
      this.button.disabled = false;
    }

    addFromActiveSource() {
      if (!this.productButton) this.bindSourceButtons();
      const source = this.mode === 'bundle' ? this.bundleButton : this.productButton;
      if (!source || source.disabled || !this.button || this.button.disabled) return;

      source.click();
      this.syncButtonFromSource();
    }
  }

  if (!customElements.get('pi-sticky-cart')) {
    customElements.define('pi-sticky-cart', PiStickyCart);
  }

  (() => {
    const bindingKey = '__seacasePiSidebarSticky';
    if (window[bindingKey] && typeof window[bindingKey].cleanup === 'function') {
      window[bindingKey].cleanup();
    }

    const controller = new AbortController();
    const signal = controller.signal;
    const mq = window.matchMedia('(min-width: 1000px)');
    let ro = null;

    const cleanup = () => {
      if (ro) {
        ro.disconnect();
        ro = null;
      }
      controller.abort();
      if (window[bindingKey] && window[bindingKey].controller === controller) {
        delete window[bindingKey];
      }
    };

    window[bindingKey] = {
      controller,
      cleanup,
    };

    const updateSidebarStickyOffset = () => {
      document.querySelectorAll('.product-block--2').forEach((sidebar) => {
        sidebar.style.setProperty('--pi-sidebar-height', `${sidebar.offsetHeight}px`);
      });
    };

    const observeSidebars = () => {
      updateSidebarStickyOffset();

      if (ro) ro.disconnect();
      if (!mq.matches || !('ResizeObserver' in window)) return;

      ro = new ResizeObserver(updateSidebarStickyOffset);
      document.querySelectorAll('.product-block--2').forEach((sidebar) => ro.observe(sidebar));
    };

    observeSidebars();
    window.addEventListener('resize', updateSidebarStickyOffset, { signal });
    mq.addEventListener('change', observeSidebars, { signal });
    document.addEventListener(
      'pi:variant-changed',
      () => {
        updateSidebarStickyOffset();
      },
      { signal }
    );
    document.addEventListener('shopify:section:unload', cleanup, { once: true, signal });
  })();

  (() => {
    const bindingKey = '__seacaseMoreDesignsRailDrag';
    if (window[bindingKey] && typeof window[bindingKey].cleanup === 'function') {
      window[bindingKey].cleanup();
    }

    const controller = new AbortController();
    const signal = controller.signal;
    const boundRails = new WeakSet();

    const bindRail = (rail) => {
      if (boundRails.has(rail)) return;
      boundRails.add(rail);

      let isDragging = false;
      let moved = false;
      let blockNextClick = false;
      let startX = 0;
      let startScrollLeft = 0;
      let capturedRailPointerId = null;
      let isScrollbarDragging = false;
      let scrollbarStartX = 0;
      let scrollbarStartScrollLeft = 0;
      const scrollbar = rail.parentElement ? rail.parentElement.querySelector('.pi2-more-designs__scrollbar') : null;
      const scrollbarThumb = scrollbar ? scrollbar.querySelector('.pi2-more-designs__scrollbar-thumb') : null;

      const isMouseLikePointer = (event) => event.pointerType === 'mouse' || event.pointerType === 'pen';
      const getScrollbarMetrics = () => {
        if (!scrollbar) return null;

        const scrollableWidth = rail.scrollWidth - rail.clientWidth;
        const trackWidth = scrollbar.clientWidth;
        if (scrollableWidth <= 1 || trackWidth <= 0) return null;

        const thumbWidth = Math.max((rail.clientWidth / rail.scrollWidth) * trackWidth, 28);
        const maxThumbOffset = Math.max(trackWidth - thumbWidth, 0);
        if (maxThumbOffset <= 0) return null;

        return {
          scrollableWidth,
          trackWidth,
          thumbWidth,
          maxThumbOffset,
        };
      };
      const updateScrollbar = () => {
        if (!scrollbar || !scrollbarThumb) return;

        const metrics = getScrollbarMetrics();
        if (!metrics) {
          scrollbar.hidden = true;
          return;
        }

        scrollbar.hidden = false;
        const thumbOffset = (rail.scrollLeft / metrics.scrollableWidth) * metrics.maxThumbOffset;

        scrollbarThumb.style.setProperty('--pi-more-designs-scrollbar-width', `${metrics.thumbWidth}px`);
        scrollbarThumb.style.setProperty('--pi-more-designs-scrollbar-offset', `${thumbOffset}px`);
      };
      const setRailScrollFromScrollbarOffset = (thumbOffset) => {
        const metrics = getScrollbarMetrics();
        if (!metrics) return;

        const clampedOffset = Math.max(0, Math.min(metrics.maxThumbOffset, thumbOffset));
        rail.scrollLeft = (clampedOffset / metrics.maxThumbOffset) * metrics.scrollableWidth;
        updateScrollbar();
      };

      rail.addEventListener(
        'pointerdown',
        (event) => {
          if (!isMouseLikePointer(event) || event.button !== 0) return;
          if (!(event.target instanceof Element)) return;
          if (event.target.closest('button, input, select, textarea, label')) return;

          isDragging = true;
          moved = false;
          startX = event.clientX;
          startScrollLeft = rail.scrollLeft;
        },
        { signal }
      );

      rail.addEventListener(
        'pointermove',
        (event) => {
          if (!isDragging) return;

          const deltaX = event.clientX - startX;
          if (Math.abs(deltaX) > 6) {
            moved = true;
            rail.classList.add('is-dragging');
            if (capturedRailPointerId == null && typeof rail.setPointerCapture === 'function') {
              rail.setPointerCapture(event.pointerId);
              capturedRailPointerId = event.pointerId;
            }
            event.preventDefault();
          }

          if (!moved) return;

          rail.scrollLeft = startScrollLeft - deltaX;
          updateScrollbar();
        },
        { signal }
      );

      const endDrag = (event) => {
        if (!isDragging) return;

        isDragging = false;
        rail.classList.remove('is-dragging');
        if (capturedRailPointerId != null && typeof rail.hasPointerCapture === 'function' && rail.hasPointerCapture(capturedRailPointerId)) {
          rail.releasePointerCapture(capturedRailPointerId);
        }
        capturedRailPointerId = null;

        if (moved) {
          blockNextClick = true;
          window.setTimeout(() => {
            blockNextClick = false;
          }, 0);
        }
      };

      rail.addEventListener('pointerup', endDrag, { signal });
      rail.addEventListener('pointercancel', endDrag, { signal });
      rail.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      rail.addEventListener('scroll', updateScrollbar, { signal, passive: true });
      window.addEventListener('resize', updateScrollbar, { signal });
      rail.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', updateScrollbar, { once: true, signal });
      });

      if (scrollbar) {
        scrollbar.addEventListener(
          'pointerdown',
          (event) => {
            if (!isMouseLikePointer(event) || event.button !== 0) return;

            const metrics = getScrollbarMetrics();
            if (!metrics) return;

            const rect = scrollbar.getBoundingClientRect();
            if (event.target !== scrollbarThumb) {
              setRailScrollFromScrollbarOffset(event.clientX - rect.left - metrics.thumbWidth / 2);
            }

            isScrollbarDragging = true;
            scrollbarStartX = event.clientX;
            scrollbarStartScrollLeft = rail.scrollLeft;
            scrollbar.classList.add('is-dragging');
            event.preventDefault();

            if (typeof scrollbar.setPointerCapture === 'function') {
              scrollbar.setPointerCapture(event.pointerId);
            }
          },
          { signal }
        );

        scrollbar.addEventListener(
          'pointermove',
          (event) => {
            if (!isScrollbarDragging) return;

            const metrics = getScrollbarMetrics();
            if (!metrics) return;

            const deltaX = event.clientX - scrollbarStartX;
            rail.scrollLeft = scrollbarStartScrollLeft + (deltaX / metrics.maxThumbOffset) * metrics.scrollableWidth;
            updateScrollbar();
            event.preventDefault();
          },
          { signal }
        );

        const endScrollbarDrag = (event) => {
          if (!isScrollbarDragging) return;

          isScrollbarDragging = false;
          scrollbar.classList.remove('is-dragging');
          if (event && typeof scrollbar.hasPointerCapture === 'function' && scrollbar.hasPointerCapture(event.pointerId)) {
            scrollbar.releasePointerCapture(event.pointerId);
          }
        };

        scrollbar.addEventListener('pointerup', endScrollbarDrag, { signal });
        scrollbar.addEventListener('pointercancel', endScrollbarDrag, { signal });
      }

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(updateScrollbar);
        ro.observe(rail);
        if (scrollbar) ro.observe(scrollbar);
        signal.addEventListener('abort', () => ro.disconnect(), { once: true });
      }

      rail.addEventListener(
        'click',
        (event) => {
          if (!blockNextClick) return;
          event.preventDefault();
          event.stopPropagation();
          blockNextClick = false;
        },
        { capture: true, signal }
      );

      requestAnimationFrame(updateScrollbar);
    };

    const bindAll = (root = document) => {
      root.querySelectorAll('.pi2-more-designs__rail').forEach(bindRail);
    };

    bindAll();
    document.addEventListener('shopify:section:load', (event) => bindAll(event.target), { signal });
    document.addEventListener('shopify:section:unload', () => controller.abort(), { once: true, signal });

    window[bindingKey] = {
      controller,
      cleanup: () => controller.abort(),
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
  class PiTabs extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();

      this.tabs = Array.from(this.querySelectorAll('[data-pi-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-pi-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.piTab), { signal: this.#controller.signal });
      });
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    activate(index) {
      this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.piTab === index));
      this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.piPanel === index));
    }
  }

  if (!customElements.get('pi-tabs')) {
    customElements.define('pi-tabs', PiTabs);
  }

  const renderPiPrice = (container, variant) => {
    if (!container) return;

    const currentPrice = container.querySelector('[data-pi-price-current]');
    const comparePrice = container.querySelector('[data-pi-price-compare]');
    const price = variant && variant.price ? variant.price : '';
    const compareAtPrice = variant && variant.compare_at_price ? variant.compare_at_price : '';

    if (currentPrice) {
      currentPrice.textContent = price;
    } else {
      container.textContent = price;
    }

    if (comparePrice) {
      comparePrice.textContent = compareAtPrice;
      comparePrice.hidden = !compareAtPrice;
    }
  };

  class PiVariant extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const signal = this.#controller.signal;

      const dataEl = this.querySelector('[data-pi-variants]');
      try {
        const variantData = dataEl ? JSON.parse(dataEl.textContent) : [];
        this.variants = Array.isArray(variantData)
          ? variantData.map((variant) => {
              if (!Array.isArray(variant)) return variant;
              const [id, options, available, price, media, image, phoneModel, compareAtPrice] = variant;
              return {
                id,
                options,
                available,
                price,
                media,
                image,
                phone_model: phoneModel,
                compare_at_price: compareAtPrice,
              };
            })
          : [];
      } catch (e) {
        this.variants = [];
      }
      this.priceEl = this.querySelector('[data-pi-price]');
      this.idInput = this.querySelector('[data-pi-variant-id]');
      this.atc = this.querySelector('[data-pi-atc]');
      this.atcText = this.querySelector('[data-pi-atc-text]');
      this.atcPrice = this.querySelector('[data-pi-atc-price]');
      this.atcSeparator = this.querySelector('[data-pi-atc-separator]');
      this.form = this.querySelector('[data-pi-atc-form]');
      this.atcError = this.querySelector('[data-pi-atc-error]');

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleAddToCart(event), { signal });
      }

      this.addEventListener('click', (event) => {
        // 按钮组 / 卡片组
        const btn = event.target.closest('.pi2-variant__value, .pi2-card');
        if (btn && this.contains(btn)) {
          const cont = btn.closest('[data-pi-opt]');
          if (cont) {
            cont.querySelectorAll('.pi2-variant__value, .pi2-card').forEach((b) => {
              b.classList.toggle('is-active', b === btn);
            });
            this.update();
          }
          return;
        }
        // 抽屉项
        const item = event.target.closest('.pi2-drawer__item');
        if (item && this.contains(item)) {
          const opt = item.closest('[data-pi-opt]');
          if (opt) {
            opt.dataset.piCurrent = item.dataset.piValue;
            const label = opt.querySelector('[data-pi-opt-label]');
            if (label) label.textContent = item.dataset.piValue;
            opt.querySelectorAll('.pi2-drawer__item').forEach((i) => {
              i.classList.toggle('is-selected', i === item);
            });
            const dlg = item.closest('dialog');
            if (dlg && typeof dlg.close === 'function') dlg.close();
            this.update();
          }
        }
      }, { signal });

      // 型号抽屉（header 组件）：只监听其广播的选中事件，后台静默切 variant
      const modelOpts = this.querySelectorAll('[data-pi-model]');
      if (modelOpts.length) {
        document.addEventListener('seacase:model-changed', (e) => {
          const source = e.detail && e.detail.source;
          if (
            this.hasAttribute('data-pi-native-variant-deep-link') &&
            (source === 'initialization' || source === 'native-variant-sync')
          ) {
            return;
          }
          const name = e.detail && e.detail.name;
          if (!name) return;
          modelOpts.forEach((o) => {
            o.dataset.piCurrent = name;
          });
          this.update();
        }, { signal });
      }

      // 通用抽屉内搜索过滤（型号抽屉由 phone-model-selector.js 自行处理搜索）
      this.querySelectorAll('.pi2-drawer__search').forEach((input) => {
        input.addEventListener('input', () => {
          const q = input.value.trim().toLowerCase();
          const scope = input.closest('.pi2-opt') || this;
          scope.querySelectorAll('.pi2-drawer__item').forEach((it) => {
            const hit = (it.dataset.piValue || '').toLowerCase().indexOf(q) !== -1;
            it.style.display = hit ? '' : 'none';
          });
          scope.querySelectorAll('.pi2-drawer__group').forEach((g) => {
            const items = Array.from(g.querySelectorAll('.pi2-drawer__item'));
            const anyVisible = items.some((it) => it.style.display !== 'none');
            g.style.display = anyVisible ? '' : 'none';
          });
        }, { signal });
      });

      // 原生 variant 深链优先于旧的 model/type 参数和本地机型缓存。
      const hasNativeVariantDeepLink = this.applyUrlSelection();
      this.toggleAttribute('data-pi-native-variant-deep-link', hasNativeVariantDeepLink);
      this.update();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    normalizeOptionValue(value) {
      return String(value || '').trim().toLowerCase();
    }

    getUrlParam(name) {
      try {
        return new URL(window.location.href).searchParams.get(name) || '';
      } catch (e) {
        return '';
      }
    }

    findMatchingElement(elements, value, getValue) {
      const target = this.normalizeOptionValue(value);
      if (!target) return null;

      return Array.from(elements).find((el) => this.normalizeOptionValue(getValue(el)) === target) || null;
    }

    findVariantById(variantId) {
      const normalizedId = String(variantId || '').trim();
      if (!normalizedId) return null;

      return this.variants.find((variant) => String(variant && variant.id) === normalizedId) || null;
    }

    applyVariantSelection(variant) {
      if (!variant || !Array.isArray(variant.options)) return;

      this.querySelectorAll('[data-pi-opt]').forEach((opt) => {
        const position = parseInt(opt.dataset.piOpt, 10) - 1;
        const value = variant.options[position];
        if (Number.isNaN(position) || value == null) return;

        opt.dataset.piCurrent = value;

        opt.querySelectorAll('.pi2-variant__value, .pi2-card').forEach((candidate) => {
          candidate.classList.toggle(
            'is-active',
            this.normalizeOptionValue(candidate.dataset.piValue) === this.normalizeOptionValue(value)
          );
        });

        const modelItem = this.findMatchingElement(
          opt.querySelectorAll('.js-model-selector-item'),
          value,
          (el) => el.dataset.item || el.textContent
        );
        opt.querySelectorAll('.js-model-selector-item').forEach((candidate) => {
          candidate.classList.toggle('is-selected', candidate === modelItem);
        });

        const drawerItem = this.findMatchingElement(
          opt.querySelectorAll('.pi2-drawer__item'),
          value,
          (el) => el.dataset.piValue
        );
        opt.querySelectorAll('.pi2-drawer__item').forEach((candidate) => {
          candidate.classList.toggle('is-selected', candidate === drawerItem);
        });

        opt.querySelectorAll('.footer-rm__select-label, [data-pi-opt-label]').forEach((label) => {
          label.textContent = value;
        });
      });
    }

    applyUrlSelection() {
      const nativeVariant = this.findVariantById(this.getUrlParam('variant'));
      if (nativeVariant) {
        this.applyVariantSelection(nativeVariant);
        return true;
      }

      // Backward compatibility for old shared links. update() converts them
      // to the native variant parameter and removes model/type from the URL.
      this.applyUrlModel(this.getUrlParam('model'));
      this.applyUrlType(this.getUrlParam('type'));
      return false;
    }

    applyUrlModel(modelName) {
      const normalizedName = String(modelName || '').trim();
      if (!normalizedName) return;

      const modelOpts = Array.from(this.querySelectorAll('[data-pi-model]'));
      if (!modelOpts.length) return;

      let matchedItem = null;
      modelOpts.forEach((opt) => {
        const item = this.findMatchingElement(
          opt.querySelectorAll('.js-model-selector-item'),
          normalizedName,
          (el) => el.dataset.item || el.textContent
        );
        if (!item) return;
        if (!matchedItem) matchedItem = item;

        const matchedName = (item.dataset.item || item.textContent || normalizedName).trim();
        opt.dataset.piCurrent = matchedName;
        opt.querySelectorAll('.footer-rm__select-label').forEach((label) => {
          label.textContent = matchedName;
        });
        opt.querySelectorAll('.js-model-selector-item').forEach((candidate) => {
          candidate.classList.toggle('is-selected', candidate === item);
        });
      });

      if (!matchedItem) return;

      const selected = {
        handle: matchedItem.dataset.modelHandle || '',
        name: (matchedItem.dataset.item || matchedItem.textContent || normalizedName).trim(),
      };

      try {
        localStorage.setItem('seacase_selected_phone_model', JSON.stringify(selected));
      } catch (e) {
        /* localStorage unavailable - ignore */
      }
      try {
        sessionStorage.setItem('seacase_selected_model', JSON.stringify(selected));
      } catch (e) {
        /* sessionStorage unavailable - ignore */
      }

      window.dispatchEvent(new CustomEvent('seacase:phone-model-change', { detail: selected }));
      document.dispatchEvent(new CustomEvent('seacase:model-changed', { detail: selected }));
    }

    applyUrlType(typeName) {
      const normalizedType = String(typeName || '').trim();
      if (!normalizedType) return;

      const card = this.findMatchingElement(
        this.querySelectorAll('.pi2-cards .pi2-card'),
        normalizedType,
        (el) => el.dataset.piValue
      );

      if (card) {
        const opt = card.closest('[data-pi-opt]');
        if (!opt) return;

        opt.querySelectorAll('.pi2-card').forEach((candidate) => {
          candidate.classList.toggle('is-active', candidate === card);
        });
        return;
      }

      const item = this.findMatchingElement(
        this.querySelectorAll('[data-pi-opt]:not([data-pi-model]) .pi2-drawer__item'),
        normalizedType,
        (el) => el.dataset.piValue
      );
      if (!item) return;

      const opt = item.closest('[data-pi-opt]');
      if (!opt) return;

      opt.dataset.piCurrent = item.dataset.piValue;
      const label = opt.querySelector('[data-pi-opt-label]');
      if (label) label.textContent = item.dataset.piValue;
      opt.querySelectorAll('.pi2-drawer__item').forEach((candidate) => {
        candidate.classList.toggle('is-selected', candidate === item);
      });
    }

    // 各 option 当前选中值，顺序 = options_with_values 顺序 = variant.options 顺序
    getSelected() {
      const opts = Array.from(this.querySelectorAll('[data-pi-opt]'));
      return opts.map((o) => {
        // 按钮组 / 卡片组
        const active = o.querySelector('.pi2-variant__value.is-active, .pi2-card.is-active');
        if (active) return active.dataset.piValue;
        const first = o.querySelector('.pi2-variant__value, .pi2-card');
        if (first) return first.dataset.piValue;
        // 抽屉控件
        return o.dataset.piCurrent || null;
      });
    }

    // 卡片组：按“当前其它 option + 该卡片值”算出对应 variant，刷新每张卡片的价格与可用态
    updateCardPrices() {
      const cards = this.querySelectorAll('.pi2-card');
      if (!cards.length) return;
      const selected = this.getSelected();
      cards.forEach((card) => {
        const cont = card.closest('[data-pi-opt]');
        if (!cont) return;
        const pos = parseInt(cont.dataset.piOpt, 10) - 1;
        const combo = selected.slice();
        combo[pos] = card.dataset.piValue;
        const v = this.findVariant(combo);
        const priceEl = card.querySelector('[data-pi-card-price]');
        renderPiPrice(priceEl, v);
        card.classList.toggle('is-unavailable', !(v && v.available));
      });
    }

    findVariant(selected) {
      return this.variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === selected.length &&
          v.options.every(
            (o, i) => this.normalizeOptionValue(o) === this.normalizeOptionValue(selected[i])
          )
      );
    }

    updateProductLinks() {
      const links = this.querySelectorAll('.pi2-more-designs__thumb, .pi-love__link');
      links.forEach((link) => {
        if (!link.href) return;

        try {
          const url = new URL(link.href, window.location.origin);
          if (url.pathname.indexOf('/products/') === -1) return;

          const cleanParams = new URLSearchParams();
          const variantId = url.searchParams.get('variant');
          if (variantId) cleanParams.set('variant', variantId);

          const cleanSearch = cleanParams.toString();
          link.setAttribute('href', `${url.pathname}${cleanSearch ? `?${cleanSearch}` : ''}${url.hash}`);
        } catch (e) {
          /* Ignore malformed URLs */
        }
      });
    }

    async handleAddToCart(event) {
      event.preventDefault();
      if (!this.form || !this.idInput || !this.atc || this.atc.disabled) return;

      const variantId = String(this.idInput.value || '').trim();
      if (!variantId) {
        this.showAddToCartError('Please select an available option.');
        return;
      }

      const quantityInput = this.form.querySelector('input[name="quantity"]');
      const quantity = Number(quantityInput && quantityInput.value) || 1;
      const previousText = this.atcText ? this.atcText.textContent : '';

      this.clearAddToCartError();
      this.atc.disabled = true;
      if (this.atcText) this.atcText.textContent = 'ADDING...';

      document.dispatchEvent(new CustomEvent('cart:open-checkout-drawer'));

      try {
        const formData = new FormData(this.form);
        formData.set('id', variantId);
        formData.set('quantity', String(quantity));

        const cartSectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((item) => item.dataset.sectionId)
          .filter(Boolean);
        if (cartSectionIds.length > 0) {
          formData.set('sections', cartSectionIds.join(','));
        }

        const response = await fetch(
          (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js',
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: formData,
          }
        );
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this item to cart.');
        }

        if (this.atcText) this.atcText.textContent = 'ADDED';
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'pi-variant',
              data: {
                source: 'product-form-component',
                itemCount: quantity,
                productId: this.form.dataset.piProductId,
                variantId,
                sections: data.sections,
              },
            },
          })
        );

        window.setTimeout(() => this.update(), 1200);
      } catch (error) {
        this.showAddToCartError(error && error.message ? error.message : 'Unable to add this item to cart.');
        if (this.atcText) this.atcText.textContent = previousText || 'ADD TO CART';
        this.atc.disabled = false;
      }
    }

    showAddToCartError(message) {
      if (!this.atcError) return;
      this.atcError.textContent = message;
      this.atcError.hidden = false;
    }

    clearAddToCartError() {
      if (!this.atcError) return;
      this.atcError.textContent = '';
      this.atcError.hidden = true;
    }

    isThemeEditorPreview() {
      return !!(
        (window.Shopify && window.Shopify.designMode) ||
        document.documentElement.classList.contains('shopify-design-mode')
      );
    }

    update() {
      const selected = this.getSelected();
      // 单变体产品没有 option 组：直接取第一个 variant
      const variant = selected.length ? this.findVariant(selected) : this.variants[0];

      // 卡片组价格随当前组合刷新
      this.updateCardPrices();

      if (variant) {
        this.clearAddToCartError();
        renderPiPrice(this.priceEl, variant);
        if (this.idInput) this.idInput.value = variant.id;
        if (this.atc) this.atc.disabled = !variant.available;
        if (this.atcText) this.atcText.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
        if (this.atcPrice) {
          renderPiPrice(this.atcPrice, variant);
          this.atcPrice.hidden = !variant.available;
        }
        if (this.atcSeparator) this.atcSeparator.hidden = !variant.available;

        if (!this.isThemeEditorPreview()) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('model');
          currentUrl.searchParams.delete('type');
          currentUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
        }
        this.updateProductLinks();

        document.dispatchEvent(
          new CustomEvent('pi:variant-changed', {
            detail: {
              variant,
              productId: this.form && this.form.dataset.piProductId,
            },
          })
        );
      } else {
        // 该属性组合不存在对应 variant
        if (this.atc) this.atc.disabled = true;
        if (this.atcText) this.atcText.textContent = 'UNAVAILABLE';
        if (this.atcPrice) this.atcPrice.hidden = true;
        if (this.atcSeparator) this.atcSeparator.hidden = true;
        document.dispatchEvent(
          new CustomEvent('pi:variant-changed', {
            detail: {
              variant: null,
              options: selected,
              productId: this.form && this.form.dataset.piProductId,
            },
          })
        );
      }
    }
  }

  if (!customElements.get('pi-variant')) {
    customElements.define('pi-variant', PiVariant);
  }

  class PiStickyCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-pi-sticky-atc]');
      this.nameEl = this.querySelector('[data-pi-sticky-name]');
      this.selectedEl = this.querySelector('[data-pi-sticky-selected]');
      this.priceEl = this.querySelector('[data-pi-sticky-price]');
      this.imageEl = this.querySelector('.pi-sticky-cart__image');
      this.productTitle = this.dataset.piStickyProductTitle || '';
      this.currentAvailable = this.button ? !this.button.disabled : true;

      this.handleScroll = () => this.updateVisibility();
      this.handleVariantChange = (event) => this.updateVariant(event.detail && event.detail.variant);
      this.handleSourceMutation = () => this.syncButtonFromSource();
      this.handleClick = () => this.addFromSourceForm();

      if (this.button) this.button.addEventListener('click', this.handleClick);
      document.addEventListener('pi:variant-changed', this.handleVariantChange);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);

      this.bindSourceButton();
      this.updateVisibility();
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.handleClick);
      document.removeEventListener('pi:variant-changed', this.handleVariantChange);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      if (this.sourceObserver) this.sourceObserver.disconnect();
    }

    bindSourceButton() {
      this.sourceButton = document.querySelector('.product-block--2 [data-pi-atc]');
      this.triggerEl =
        document.querySelector('.product-block--2 .pi2-tabs__tab[data-pi-tab="0"]') ||
        document.querySelector('.product-block--2 .pi2-tabs__nav') ||
        this.sourceButton;
      if (!this.sourceButton || !('MutationObserver' in window)) return;

      if (this.sourceObserver) this.sourceObserver.disconnect();
      this.sourceObserver = new MutationObserver(this.handleSourceMutation);
      this.sourceObserver.observe(this.sourceButton, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
      this.syncButtonFromSource();
    }

    updateVisibility() {
      if (!this.sourceButton || !this.triggerEl) this.bindSourceButton();
      if (!this.triggerEl) return;

      const triggerRect = this.triggerEl.getBoundingClientRect();
      const shouldShow = triggerRect.bottom <= 0;
      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    updateVariant(variant) {
      if (!variant) return;

      this.currentAvailable = Boolean(variant.available);
      if (this.nameEl) {
        const phoneModel = String(variant.phone_model || '').trim();
        this.nameEl.textContent = phoneModel ? `${this.productTitle} - ${phoneModel} Case` : this.productTitle;
      }
      if (this.selectedEl && Array.isArray(variant.options)) {
        const phoneModel = String(variant.phone_model || '').trim();
        const selectedText = variant.options
          .filter(Boolean)
          .filter((option) => String(option).trim() !== phoneModel)
          .join(' / ');
        this.selectedEl.textContent = selectedText;
        this.selectedEl.hidden = selectedText === '';
      }
      renderPiPrice(this.priceEl, variant);
      if (this.imageEl && variant.image) {
        this.imageEl.removeAttribute('srcset');
        this.imageEl.src = variant.image;
      }
      this.syncButtonFromSource();
    }

    syncButtonFromSource() {
      if (!this.button) return;

      const sourceText = this.sourceButton
        ? (this.sourceButton.querySelector('[data-pi-atc-text]') || this.sourceButton).textContent.trim()
        : '';

      if (sourceText === 'ADDING...' || sourceText === 'ADDED') {
        this.button.textContent = sourceText;
        this.button.disabled = true;
        return;
      }

      if (sourceText === 'SOLD OUT' || sourceText === 'UNAVAILABLE' || !this.currentAvailable) {
        this.button.textContent = sourceText || 'SOLD OUT';
        this.button.disabled = true;
        return;
      }

      this.button.textContent = 'ADD TO CART';
      this.button.disabled = false;
    }

    addFromSourceForm() {
      if (!this.sourceButton) this.bindSourceButton();
      if (!this.sourceButton || this.sourceButton.disabled || !this.button || this.button.disabled) return;

      this.sourceButton.click();
      this.syncButtonFromSource();
    }
  }

  if (!customElements.get('pi-sticky-cart')) {
    customElements.define('pi-sticky-cart', PiStickyCart);
  }

  (() => {
    const bindingKey = '__seacasePiSidebarSticky';
    if (window[bindingKey] && typeof window[bindingKey].cleanup === 'function') {
      window[bindingKey].cleanup();
    }

    const controller = new AbortController();
    const signal = controller.signal;
    const mq = window.matchMedia('(min-width: 1000px)');
    let ro = null;

    const cleanup = () => {
      if (ro) {
        ro.disconnect();
        ro = null;
      }
      controller.abort();
      if (window[bindingKey] && window[bindingKey].controller === controller) {
        delete window[bindingKey];
      }
    };

    window[bindingKey] = {
      controller,
      cleanup,
    };

    const updateSidebarStickyOffset = () => {
      document.querySelectorAll('.product-block--2').forEach((sidebar) => {
        sidebar.style.setProperty('--pi-sidebar-height', `${sidebar.offsetHeight}px`);
      });
    };

    const observeSidebars = () => {
      updateSidebarStickyOffset();

      if (ro) ro.disconnect();
      if (!mq.matches || !('ResizeObserver' in window)) return;

      ro = new ResizeObserver(updateSidebarStickyOffset);
      document.querySelectorAll('.product-block--2').forEach((sidebar) => ro.observe(sidebar));
    };

    observeSidebars();
    window.addEventListener('resize', updateSidebarStickyOffset, { signal });
    mq.addEventListener('change', observeSidebars, { signal });
    document.addEventListener(
      'pi:variant-changed',
      () => {
        updateSidebarStickyOffset();
      },
      { signal }
    );
    document.addEventListener('shopify:section:unload', cleanup, { once: true, signal });
  })();

  (() => {
    const bindingKey = '__seacaseMoreDesignsRailDrag';
    if (window[bindingKey] && typeof window[bindingKey].cleanup === 'function') {
      window[bindingKey].cleanup();
    }

    const controller = new AbortController();
    const signal = controller.signal;
    const boundRails = new WeakSet();

    const bindRail = (rail) => {
      if (boundRails.has(rail)) return;
      boundRails.add(rail);

      let isDragging = false;
      let moved = false;
      let blockNextClick = false;
      let startX = 0;
      let startScrollLeft = 0;
      let capturedRailPointerId = null;
      let isScrollbarDragging = false;
      let scrollbarStartX = 0;
      let scrollbarStartScrollLeft = 0;
      const scrollbar = rail.parentElement ? rail.parentElement.querySelector('.pi2-more-designs__scrollbar') : null;
      const scrollbarThumb = scrollbar ? scrollbar.querySelector('.pi2-more-designs__scrollbar-thumb') : null;

      const isMouseLikePointer = (event) => event.pointerType === 'mouse' || event.pointerType === 'pen';
      const getScrollbarMetrics = () => {
        if (!scrollbar) return null;

        const scrollableWidth = rail.scrollWidth - rail.clientWidth;
        const trackWidth = scrollbar.clientWidth;
        if (scrollableWidth <= 1 || trackWidth <= 0) return null;

        const thumbWidth = Math.max((rail.clientWidth / rail.scrollWidth) * trackWidth, 28);
        const maxThumbOffset = Math.max(trackWidth - thumbWidth, 0);
        if (maxThumbOffset <= 0) return null;

        return {
          scrollableWidth,
          trackWidth,
          thumbWidth,
          maxThumbOffset,
        };
      };
      const updateScrollbar = () => {
        if (!scrollbar || !scrollbarThumb) return;

        const metrics = getScrollbarMetrics();
        if (!metrics) {
          scrollbar.hidden = true;
          return;
        }

        scrollbar.hidden = false;
        const thumbOffset = (rail.scrollLeft / metrics.scrollableWidth) * metrics.maxThumbOffset;

        scrollbarThumb.style.setProperty('--pi-more-designs-scrollbar-width', `${metrics.thumbWidth}px`);
        scrollbarThumb.style.setProperty('--pi-more-designs-scrollbar-offset', `${thumbOffset}px`);
      };
      const setRailScrollFromScrollbarOffset = (thumbOffset) => {
        const metrics = getScrollbarMetrics();
        if (!metrics) return;

        const clampedOffset = Math.max(0, Math.min(metrics.maxThumbOffset, thumbOffset));
        rail.scrollLeft = (clampedOffset / metrics.maxThumbOffset) * metrics.scrollableWidth;
        updateScrollbar();
      };

      rail.addEventListener(
        'pointerdown',
        (event) => {
          if (!isMouseLikePointer(event) || event.button !== 0) return;
          if (!(event.target instanceof Element)) return;
          if (event.target.closest('button, input, select, textarea, label')) return;

          isDragging = true;
          moved = false;
          startX = event.clientX;
          startScrollLeft = rail.scrollLeft;
        },
        { signal }
      );

      rail.addEventListener(
        'pointermove',
        (event) => {
          if (!isDragging) return;

          const deltaX = event.clientX - startX;
          if (Math.abs(deltaX) > 6) {
            moved = true;
            rail.classList.add('is-dragging');
            if (capturedRailPointerId == null && typeof rail.setPointerCapture === 'function') {
              rail.setPointerCapture(event.pointerId);
              capturedRailPointerId = event.pointerId;
            }
            event.preventDefault();
          }

          if (!moved) return;

          rail.scrollLeft = startScrollLeft - deltaX;
          updateScrollbar();
        },
        { signal }
      );

      const endDrag = (event) => {
        if (!isDragging) return;

        isDragging = false;
        rail.classList.remove('is-dragging');
        if (capturedRailPointerId != null && typeof rail.hasPointerCapture === 'function' && rail.hasPointerCapture(capturedRailPointerId)) {
          rail.releasePointerCapture(capturedRailPointerId);
        }
        capturedRailPointerId = null;

        if (moved) {
          blockNextClick = true;
          window.setTimeout(() => {
            blockNextClick = false;
          }, 0);
        }
      };

      rail.addEventListener('pointerup', endDrag, { signal });
      rail.addEventListener('pointercancel', endDrag, { signal });
      rail.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      rail.addEventListener('scroll', updateScrollbar, { signal, passive: true });
      window.addEventListener('resize', updateScrollbar, { signal });
      rail.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', updateScrollbar, { once: true, signal });
      });

      if (scrollbar) {
        scrollbar.addEventListener(
          'pointerdown',
          (event) => {
            if (!isMouseLikePointer(event) || event.button !== 0) return;

            const metrics = getScrollbarMetrics();
            if (!metrics) return;

            const rect = scrollbar.getBoundingClientRect();
            if (event.target !== scrollbarThumb) {
              setRailScrollFromScrollbarOffset(event.clientX - rect.left - metrics.thumbWidth / 2);
            }

            isScrollbarDragging = true;
            scrollbarStartX = event.clientX;
            scrollbarStartScrollLeft = rail.scrollLeft;
            scrollbar.classList.add('is-dragging');
            event.preventDefault();

            if (typeof scrollbar.setPointerCapture === 'function') {
              scrollbar.setPointerCapture(event.pointerId);
            }
          },
          { signal }
        );

        scrollbar.addEventListener(
          'pointermove',
          (event) => {
            if (!isScrollbarDragging) return;

            const metrics = getScrollbarMetrics();
            if (!metrics) return;

            const deltaX = event.clientX - scrollbarStartX;
            rail.scrollLeft = scrollbarStartScrollLeft + (deltaX / metrics.maxThumbOffset) * metrics.scrollableWidth;
            updateScrollbar();
            event.preventDefault();
          },
          { signal }
        );

        const endScrollbarDrag = (event) => {
          if (!isScrollbarDragging) return;

          isScrollbarDragging = false;
          scrollbar.classList.remove('is-dragging');
          if (event && typeof scrollbar.hasPointerCapture === 'function' && scrollbar.hasPointerCapture(event.pointerId)) {
            scrollbar.releasePointerCapture(event.pointerId);
          }
        };

        scrollbar.addEventListener('pointerup', endScrollbarDrag, { signal });
        scrollbar.addEventListener('pointercancel', endScrollbarDrag, { signal });
      }

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(updateScrollbar);
        ro.observe(rail);
        if (scrollbar) ro.observe(scrollbar);
        signal.addEventListener('abort', () => ro.disconnect(), { once: true });
      }

      rail.addEventListener(
        'click',
        (event) => {
          if (!blockNextClick) return;
          event.preventDefault();
          event.stopPropagation();
          blockNextClick = false;
        },
        { capture: true, signal }
      );

      requestAnimationFrame(updateScrollbar);
    };

    const bindAll = (root = document) => {
      root.querySelectorAll('.pi2-more-designs__rail').forEach(bindRail);
    };

    bindAll();
    document.addEventListener('shopify:section:load', (event) => bindAll(event.target), { signal });
    document.addEventListener('shopify:section:unload', () => controller.abort(), { once: true, signal });

    window[bindingKey] = {
      controller,
      cleanup: () => controller.abort(),
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-seame-information"] && !Shopify.designMode) return;
  try {
    
  class PiTabs extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const signal = this.#controller.signal;

      this.tabs = Array.from(this.querySelectorAll('[data-pi-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-pi-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener(
          'click',
          () => {
            if (!this.locked) this.activate(tab.dataset.piTab);
          },
          { signal }
        );
        tab.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      });

      const initialTab =
        this.tabs.find((tab) => tab.classList.contains('is-active') && !tab.hidden) ||
        this.tabs.find((tab) => !tab.hidden);
      if (initialTab) this.activate(initialTab.dataset.piTab);
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    handleKeydown(event) {
      if (this.locked) return;
      const availableTabs = this.tabs.filter((tab) => !tab.hidden && !tab.disabled);
      const currentIndex = availableTabs.indexOf(event.currentTarget);
      if (currentIndex < 0) return;

      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % availableTabs.length;
      if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + availableTabs.length) % availableTabs.length;
      }
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = availableTabs.length - 1;
      if (nextIndex == null) return;

      event.preventDefault();
      const nextTab = availableTabs[nextIndex];
      this.activate(nextTab.dataset.piTab, { focus: true });
    }

    activate(index, options = {}) {
      const targetTab = this.tabs.find(
        (tab) => tab.dataset.piTab === index && !tab.hidden && !tab.disabled
      );
      if (!targetTab) return;

      this.tabs.forEach((tab) => {
        const active = tab === targetTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.piPanel === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (options.focus) targetTab.focus();
      document.dispatchEvent(
        new CustomEvent('pi:tab-changed', {
          detail: {
            tab: index,
            tabs: this,
          },
        })
      );
    }
  }

  if (!customElements.get('pi-tabs')) {
    customElements.define('pi-tabs', PiTabs);
  }

  const renderPiPrice = (container, variant) => {
    if (!container) return;

    const currentPrice = container.querySelector('[data-pi-price-current]');
    const comparePrice = container.querySelector('[data-pi-price-compare]');
    const price = variant && variant.price ? variant.price : '';
    const compareAtPrice = variant && variant.compare_at_price ? variant.compare_at_price : '';

    if (currentPrice) {
      currentPrice.textContent = price;
    } else {
      container.textContent = price;
    }

    if (comparePrice) {
      comparePrice.textContent = compareAtPrice;
      comparePrice.hidden = !compareAtPrice;
    }
  };

  class PiVariant extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const signal = this.#controller.signal;

      const dataEl = this.querySelector('[data-pi-variants]');
      try {
        const variantData = dataEl ? JSON.parse(dataEl.textContent) : [];
        this.variants = Array.isArray(variantData)
          ? variantData.map((variant) => {
              if (!Array.isArray(variant)) return variant;
              const [id, options, available, price, media, image, phoneModel, compareAtPrice] = variant;
              return {
                id,
                options,
                available,
                price,
                media,
                image,
                phone_model: phoneModel,
                compare_at_price: compareAtPrice,
              };
            })
          : [];
      } catch (e) {
        this.variants = [];
      }
      this.priceEl = this.querySelector('[data-pi-price]');
      this.idInput = this.querySelector('[data-pi-variant-id]');
      this.atc = this.querySelector('[data-pi-atc]');
      this.atcText = this.querySelector('[data-pi-atc-text]');
      this.atcPrice = this.querySelector('[data-pi-atc-price]');
      this.atcSeparator = this.querySelector('[data-pi-atc-separator]');
      this.form = this.querySelector('[data-pi-atc-form]');
      this.atcError = this.querySelector('[data-pi-atc-error]');

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleAddToCart(event), { signal });
      }

      this.addEventListener('click', (event) => {
        // 按钮组 / 卡片组
        const btn = event.target.closest('.pi2-variant__value, .pi2-card');
        if (btn && this.contains(btn)) {
          const cont = btn.closest('[data-pi-opt]');
          if (cont) {
            cont.querySelectorAll('.pi2-variant__value, .pi2-card').forEach((b) => {
              b.classList.toggle('is-active', b === btn);
            });
            this.update();
          }
          return;
        }
        // 抽屉项
        const item = event.target.closest('.pi2-drawer__item');
        if (item && this.contains(item)) {
          const opt = item.closest('[data-pi-opt]');
          if (opt) {
            opt.dataset.piCurrent = item.dataset.piValue;
            const label = opt.querySelector('[data-pi-opt-label]');
            if (label) label.textContent = item.dataset.piValue;
            opt.querySelectorAll('.pi2-drawer__item').forEach((i) => {
              i.classList.toggle('is-selected', i === item);
            });
            const dlg = item.closest('dialog');
            if (dlg && typeof dlg.close === 'function') dlg.close();
            this.update();
          }
        }
      }, { signal });

      // 通用 variant 抽屉内搜索过滤；Case 型号导航使用独立组件。
      this.querySelectorAll('.pi2-drawer__search').forEach((input) => {
        input.addEventListener('input', () => {
          const q = input.value.trim().toLowerCase();
          const scope = input.closest('.pi2-opt') || this;
          scope.querySelectorAll('.pi2-drawer__item').forEach((it) => {
            const hit = (it.dataset.piValue || '').toLowerCase().indexOf(q) !== -1;
            it.style.display = hit ? '' : 'none';
          });
          scope.querySelectorAll('.pi2-drawer__group').forEach((g) => {
            const items = Array.from(g.querySelectorAll('.pi2-drawer__item'));
            const anyVisible = items.some((it) => it.style.display !== 'none');
            g.style.display = anyVisible ? '' : 'none';
          });
        }, { signal });
      });

      // 原生 variant 深链优先；兼容旧的 type 参数。
      this.applyUrlSelection();
      this.update();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    normalizeOptionValue(value) {
      return String(value || '').trim().toLowerCase();
    }

    getUrlParam(name) {
      try {
        return new URL(window.location.href).searchParams.get(name) || '';
      } catch (e) {
        return '';
      }
    }

    findMatchingElement(elements, value, getValue) {
      const target = this.normalizeOptionValue(value);
      if (!target) return null;

      return Array.from(elements).find((el) => this.normalizeOptionValue(getValue(el)) === target) || null;
    }

    findVariantById(variantId) {
      const normalizedId = String(variantId || '').trim();
      if (!normalizedId) return null;

      return this.variants.find((variant) => String(variant && variant.id) === normalizedId) || null;
    }

    applyVariantSelection(variant) {
      if (!variant || !Array.isArray(variant.options)) return;

      this.querySelectorAll('[data-pi-opt]').forEach((opt) => {
        const position = parseInt(opt.dataset.piOpt, 10) - 1;
        const value = variant.options[position];
        if (Number.isNaN(position) || value == null) return;

        opt.dataset.piCurrent = value;

        opt.querySelectorAll('.pi2-variant__value, .pi2-card').forEach((candidate) => {
          candidate.classList.toggle(
            'is-active',
            this.normalizeOptionValue(candidate.dataset.piValue) === this.normalizeOptionValue(value)
          );
        });

        const drawerItem = this.findMatchingElement(
          opt.querySelectorAll('.pi2-drawer__item'),
          value,
          (el) => el.dataset.piValue
        );
        opt.querySelectorAll('.pi2-drawer__item').forEach((candidate) => {
          candidate.classList.toggle('is-selected', candidate === drawerItem);
        });

        opt.querySelectorAll('.footer-rm__select-label, [data-pi-opt-label]').forEach((label) => {
          label.textContent = value;
        });
      });
    }

    applyUrlSelection() {
      const nativeVariant = this.findVariantById(this.getUrlParam('variant'));
      if (nativeVariant) {
        this.applyVariantSelection(nativeVariant);
        return true;
      }

      // Backward compatibility for the old type parameter.
      this.applyUrlType(this.getUrlParam('type'));
      return false;
    }

    applyUrlType(typeName) {
      const normalizedType = String(typeName || '').trim();
      if (!normalizedType) return;

      const card = this.findMatchingElement(
        this.querySelectorAll('.pi2-cards .pi2-card'),
        normalizedType,
        (el) => el.dataset.piValue
      );

      if (card) {
        const opt = card.closest('[data-pi-opt]');
        if (!opt) return;

        opt.querySelectorAll('.pi2-card').forEach((candidate) => {
          candidate.classList.toggle('is-active', candidate === card);
        });
        return;
      }

      const item = this.findMatchingElement(
        this.querySelectorAll('[data-pi-opt] .pi2-drawer__item'),
        normalizedType,
        (el) => el.dataset.piValue
      );
      if (!item) return;

      const opt = item.closest('[data-pi-opt]');
      if (!opt) return;

      opt.dataset.piCurrent = item.dataset.piValue;
      const label = opt.querySelector('[data-pi-opt-label]');
      if (label) label.textContent = item.dataset.piValue;
      opt.querySelectorAll('.pi2-drawer__item').forEach((candidate) => {
        candidate.classList.toggle('is-selected', candidate === item);
      });
    }

    // 各 option 当前选中值，顺序 = options_with_values 顺序 = variant.options 顺序
    getSelected() {
      const opts = Array.from(this.querySelectorAll('[data-pi-opt]'));
      return opts.map((o) => {
        // 按钮组 / 卡片组
        const active = o.querySelector('.pi2-variant__value.is-active, .pi2-card.is-active');
        if (active) return active.dataset.piValue;
        const first = o.querySelector('.pi2-variant__value, .pi2-card');
        if (first) return first.dataset.piValue;
        // 抽屉控件
        return o.dataset.piCurrent || null;
      });
    }

    // 卡片组：按“当前其它 option + 该卡片值”算出对应 variant，刷新每张卡片的价格与可用态
    updateCardPrices() {
      const cards = this.querySelectorAll('.pi2-card');
      if (!cards.length) return;
      const selected = this.getSelected();
      cards.forEach((card) => {
        const cont = card.closest('[data-pi-opt]');
        if (!cont) return;
        const pos = parseInt(cont.dataset.piOpt, 10) - 1;
        const combo = selected.slice();
        combo[pos] = card.dataset.piValue;
        const v = this.findVariant(combo);
        const priceEl = card.querySelector('[data-pi-card-price]');
        renderPiPrice(priceEl, v);
        card.classList.toggle('is-unavailable', !(v && v.available));
      });
    }

    findVariant(selected) {
      return this.variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === selected.length &&
          v.options.every(
            (o, i) => this.normalizeOptionValue(o) === this.normalizeOptionValue(selected[i])
          )
      );
    }

    updateProductLinks() {
      const links = this.querySelectorAll('.pi2-more-designs__thumb, .pi-love__link');
      links.forEach((link) => {
        if (!link.href) return;

        try {
          const url = new URL(link.href, window.location.origin);
          if (url.pathname.indexOf('/products/') === -1) return;

          const cleanParams = new URLSearchParams();
          const variantId = url.searchParams.get('variant');
          if (variantId) cleanParams.set('variant', variantId);

          const cleanSearch = cleanParams.toString();
          link.setAttribute('href', `${url.pathname}${cleanSearch ? `?${cleanSearch}` : ''}${url.hash}`);
        } catch (e) {
          /* Ignore malformed URLs */
        }
      });
    }

    async handleAddToCart(event) {
      event.preventDefault();
      if (!this.form || !this.idInput || !this.atc || this.atc.disabled) return;

      const variantId = String(this.idInput.value || '').trim();
      if (!variantId) {
        this.showAddToCartError('Please select an available option.');
        return;
      }

      const quantityInput = this.form.querySelector('input[name="quantity"]');
      const quantity = Number(quantityInput && quantityInput.value) || 1;
      const previousText = this.atcText ? this.atcText.textContent : '';

      this.clearAddToCartError();
      this.atc.disabled = true;
      if (this.atcText) this.atcText.textContent = 'ADDING...';

      document.dispatchEvent(new CustomEvent('cart:open-checkout-drawer'));

      try {
        const formData = new FormData(this.form);
        formData.set('id', variantId);
        formData.set('quantity', String(quantity));

        const cartSectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((item) => item.dataset.sectionId)
          .filter(Boolean);
        if (cartSectionIds.length > 0) {
          formData.set('sections', cartSectionIds.join(','));
        }

        const response = await fetch(
          (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js',
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: formData,
          }
        );
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this item to cart.');
        }

        if (this.atcText) this.atcText.textContent = 'ADDED';
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'pi-variant',
              data: {
                source: 'product-form-component',
                itemCount: quantity,
                productId: this.form.dataset.piProductId,
                variantId,
                sections: data.sections,
              },
            },
          })
        );

        window.setTimeout(() => this.update(), 1200);
      } catch (error) {
        this.showAddToCartError(error && error.message ? error.message : 'Unable to add this item to cart.');
        if (this.atcText) this.atcText.textContent = previousText || 'ADD TO CART';
        this.atc.disabled = false;
      }
    }

    showAddToCartError(message) {
      if (!this.atcError) return;
      this.atcError.textContent = message;
      this.atcError.hidden = false;
    }

    clearAddToCartError() {
      if (!this.atcError) return;
      this.atcError.textContent = '';
      this.atcError.hidden = true;
    }

    isThemeEditorPreview() {
      return !!(
        (window.Shopify && window.Shopify.designMode) ||
        document.documentElement.classList.contains('shopify-design-mode')
      );
    }

    update() {
      const selected = this.getSelected();
      // 单变体产品没有 option 组：直接取第一个 variant
      const variant = selected.length ? this.findVariant(selected) : this.variants[0];

      // 卡片组价格随当前组合刷新
      this.updateCardPrices();

      if (variant) {
        this.clearAddToCartError();
        renderPiPrice(this.priceEl, variant);
        if (this.idInput) this.idInput.value = variant.id;
        if (this.atc) this.atc.disabled = !variant.available;
        if (this.atcText) this.atcText.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
        if (this.atcPrice) {
          renderPiPrice(this.atcPrice, variant);
          this.atcPrice.hidden = !variant.available;
        }
        if (this.atcSeparator) this.atcSeparator.hidden = !variant.available;

        if (!this.isThemeEditorPreview()) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('model');
          currentUrl.searchParams.delete('type');
          currentUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
        }
        this.updateProductLinks();

        document.dispatchEvent(
          new CustomEvent('pi:variant-changed', {
            detail: {
              variant,
              productId: this.form && this.form.dataset.piProductId,
            },
          })
        );
      } else {
        // 该属性组合不存在对应 variant
        if (this.atc) this.atc.disabled = true;
        if (this.atcText) this.atcText.textContent = 'UNAVAILABLE';
        if (this.atcPrice) this.atcPrice.hidden = true;
        if (this.atcSeparator) this.atcSeparator.hidden = true;
        document.dispatchEvent(
          new CustomEvent('pi:variant-changed', {
            detail: {
              variant: null,
              options: selected,
              productId: this.form && this.form.dataset.piProductId,
            },
          })
        );
      }
    }
  }

  if (!customElements.get('pi-variant')) {
    customElements.define('pi-variant', PiVariant);
  }

  class PiStickyCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-pi-sticky-atc]');
      this.nameEl = this.querySelector('[data-pi-sticky-name]');
      this.selectedEl = this.querySelector('[data-pi-sticky-selected]');
      this.priceEl = this.querySelector('[data-pi-sticky-price]');
      this.imageEl = this.querySelector('.pi-sticky-cart__image');
      this.productTitle = this.dataset.piStickyProductTitle || '';
      this.currentAvailable = this.button ? !this.button.disabled : true;
      this.currentVariant = null;
      this.productSnapshot = {
        name: this.nameEl?.textContent || this.productTitle,
        selected: this.selectedEl?.textContent || '',
        selectedHidden: this.selectedEl?.hidden ?? true,
        price: this.priceEl?.querySelector('[data-pi-price-current]')?.textContent || '',
        comparePrice: this.priceEl?.querySelector('[data-pi-price-compare]')?.textContent || '',
        image: this.imageEl?.currentSrc || this.imageEl?.src || '',
        available: this.currentAvailable,
      };

      this.handleScroll = () => this.updateVisibility();
      this.handleVariantChange = (event) => {
        this.currentVariant = event.detail && event.detail.variant;
        this.renderProductMode();
      };
      this.handleSourceMutation = () => this.syncButtonFromSource();
      this.handleClick = () => this.addFromActiveSource();

      if (this.button) this.button.addEventListener('click', this.handleClick);
      document.addEventListener('pi:variant-changed', this.handleVariantChange);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);

      this.bindSourceButtons();
      this.updateVisibility();
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.handleClick);
      document.removeEventListener('pi:variant-changed', this.handleVariantChange);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      this.sourceObservers?.forEach((observer) => observer.disconnect());
    }

    bindSourceButtons() {
      this.productButton = document.querySelector('.product-block--2 [data-pi-atc]');
      this.triggerEl =
        document.querySelector('.product-block--2 .pi2-tabs__nav') ||
        this.productButton;
      if (!('MutationObserver' in window)) return;

      this.sourceObservers?.forEach((observer) => observer.disconnect());
      this.sourceObservers = [this.productButton].filter(Boolean).map((source) => {
        const observer = new MutationObserver(this.handleSourceMutation);
        observer.observe(source, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        });
        return observer;
      });
      this.syncButtonFromSource();
    }

    updateVisibility() {
      if (!this.productButton || !this.triggerEl) this.bindSourceButtons();
      if (!this.triggerEl) return;

      const triggerRect = this.triggerEl.getBoundingClientRect();
      const shouldShow = triggerRect.bottom <= 0;
      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    renderProductMode() {
      const variant = this.currentVariant;
      if (!variant) {
        this.currentAvailable = this.productSnapshot.available;
        if (this.nameEl) this.nameEl.textContent = this.productSnapshot.name;
        if (this.selectedEl) {
          this.selectedEl.textContent = this.productSnapshot.selected;
          this.selectedEl.hidden = this.productSnapshot.selectedHidden;
        }
        renderPiPrice(this.priceEl, {
          price: this.productSnapshot.price,
          compare_at_price: this.productSnapshot.comparePrice,
        });
        if (this.imageEl && this.productSnapshot.image) this.imageEl.src = this.productSnapshot.image;
        this.syncButtonFromSource();
        return;
      }

      this.currentAvailable = Boolean(variant.available);
      if (this.nameEl) {
        const phoneModel = String(variant.phone_model || '').trim();
        this.nameEl.textContent = phoneModel ? `${this.productTitle} - ${phoneModel} Case` : this.productTitle;
      }
      if (this.selectedEl && Array.isArray(variant.options)) {
        const phoneModel = String(variant.phone_model || '').trim();
        const selectedText = variant.options
          .filter(Boolean)
          .filter((option) => String(option).trim() !== phoneModel)
          .join(' / ');
        this.selectedEl.textContent = selectedText;
        this.selectedEl.hidden = selectedText === '';
      }
      renderPiPrice(this.priceEl, variant);
      if (this.imageEl && variant.image) {
        this.imageEl.removeAttribute('srcset');
        this.imageEl.src = variant.image;
      }
      this.syncButtonFromSource();
    }

    syncButtonFromSource() {
      if (!this.button) return;

      const sourceText = this.productButton
        ? (this.productButton.querySelector('[data-pi-atc-text]') || this.productButton).textContent.trim()
        : '';

      if (sourceText === 'ADDING...' || sourceText === 'ADDED') {
        this.button.textContent = sourceText;
        this.button.disabled = true;
        return;
      }

      if (sourceText === 'SOLD OUT' || sourceText === 'UNAVAILABLE' || !this.currentAvailable) {
        this.button.textContent = sourceText || 'SOLD OUT';
        this.button.disabled = true;
        return;
      }

      this.button.textContent = 'ADD TO CART';
      this.button.disabled = false;
    }

    addFromActiveSource() {
      if (!this.productButton) this.bindSourceButtons();
      const source = this.productButton;
      if (!source || source.disabled || !this.button || this.button.disabled) return;

      source.click();
      this.syncButtonFromSource();
    }
  }

  if (!customElements.get('pi-sticky-cart')) {
    customElements.define('pi-sticky-cart', PiStickyCart);
  }

  (() => {
    const bindingKey = '__seacasePiSidebarSticky';
    if (window[bindingKey] && typeof window[bindingKey].cleanup === 'function') {
      window[bindingKey].cleanup();
    }

    const controller = new AbortController();
    const signal = controller.signal;
    const mq = window.matchMedia('(min-width: 1000px)');
    let ro = null;

    const cleanup = () => {
      if (ro) {
        ro.disconnect();
        ro = null;
      }
      controller.abort();
      if (window[bindingKey] && window[bindingKey].controller === controller) {
        delete window[bindingKey];
      }
    };

    window[bindingKey] = {
      controller,
      cleanup,
    };

    const updateSidebarStickyOffset = () => {
      document.querySelectorAll('.product-block--2').forEach((sidebar) => {
        sidebar.style.setProperty('--pi-sidebar-height', `${sidebar.offsetHeight}px`);
      });
    };

    const observeSidebars = () => {
      updateSidebarStickyOffset();

      if (ro) ro.disconnect();
      if (!mq.matches || !('ResizeObserver' in window)) return;

      ro = new ResizeObserver(updateSidebarStickyOffset);
      document.querySelectorAll('.product-block--2').forEach((sidebar) => ro.observe(sidebar));
    };

    observeSidebars();
    window.addEventListener('resize', updateSidebarStickyOffset, { signal });
    mq.addEventListener('change', observeSidebars, { signal });
    document.addEventListener(
      'pi:variant-changed',
      () => {
        updateSidebarStickyOffset();
      },
      { signal }
    );
    document.addEventListener('shopify:section:unload', cleanup, { once: true, signal });
  })();

  (() => {
    const bindingKey = '__seacaseMoreDesignsRailDrag';
    if (window[bindingKey] && typeof window[bindingKey].cleanup === 'function') {
      window[bindingKey].cleanup();
    }

    const controller = new AbortController();
    const signal = controller.signal;
    const boundRails = new WeakSet();

    const bindRail = (rail) => {
      if (boundRails.has(rail)) return;
      boundRails.add(rail);

      let isDragging = false;
      let moved = false;
      let blockNextClick = false;
      let startX = 0;
      let startScrollLeft = 0;
      let capturedRailPointerId = null;
      let isScrollbarDragging = false;
      let scrollbarStartX = 0;
      let scrollbarStartScrollLeft = 0;
      const scrollbar = rail.parentElement ? rail.parentElement.querySelector('.pi2-more-designs__scrollbar') : null;
      const scrollbarThumb = scrollbar ? scrollbar.querySelector('.pi2-more-designs__scrollbar-thumb') : null;

      const isMouseLikePointer = (event) => event.pointerType === 'mouse' || event.pointerType === 'pen';
      const getScrollbarMetrics = () => {
        if (!scrollbar) return null;

        const scrollableWidth = rail.scrollWidth - rail.clientWidth;
        const trackWidth = scrollbar.clientWidth;
        if (scrollableWidth <= 1 || trackWidth <= 0) return null;

        const thumbWidth = Math.max((rail.clientWidth / rail.scrollWidth) * trackWidth, 28);
        const maxThumbOffset = Math.max(trackWidth - thumbWidth, 0);
        if (maxThumbOffset <= 0) return null;

        return {
          scrollableWidth,
          trackWidth,
          thumbWidth,
          maxThumbOffset,
        };
      };
      const updateScrollbar = () => {
        if (!scrollbar || !scrollbarThumb) return;

        const metrics = getScrollbarMetrics();
        if (!metrics) {
          scrollbar.hidden = true;
          return;
        }

        scrollbar.hidden = false;
        const thumbOffset = (rail.scrollLeft / metrics.scrollableWidth) * metrics.maxThumbOffset;

        scrollbarThumb.style.setProperty('--pi-more-designs-scrollbar-width', `${metrics.thumbWidth}px`);
        scrollbarThumb.style.setProperty('--pi-more-designs-scrollbar-offset', `${thumbOffset}px`);
      };
      const setRailScrollFromScrollbarOffset = (thumbOffset) => {
        const metrics = getScrollbarMetrics();
        if (!metrics) return;

        const clampedOffset = Math.max(0, Math.min(metrics.maxThumbOffset, thumbOffset));
        rail.scrollLeft = (clampedOffset / metrics.maxThumbOffset) * metrics.scrollableWidth;
        updateScrollbar();
      };

      rail.addEventListener(
        'pointerdown',
        (event) => {
          if (!isMouseLikePointer(event) || event.button !== 0) return;
          if (!(event.target instanceof Element)) return;
          if (event.target.closest('button, input, select, textarea, label')) return;

          isDragging = true;
          moved = false;
          startX = event.clientX;
          startScrollLeft = rail.scrollLeft;
        },
        { signal }
      );

      rail.addEventListener(
        'pointermove',
        (event) => {
          if (!isDragging) return;

          const deltaX = event.clientX - startX;
          if (Math.abs(deltaX) > 6) {
            moved = true;
            rail.classList.add('is-dragging');
            if (capturedRailPointerId == null && typeof rail.setPointerCapture === 'function') {
              rail.setPointerCapture(event.pointerId);
              capturedRailPointerId = event.pointerId;
            }
            event.preventDefault();
          }

          if (!moved) return;

          rail.scrollLeft = startScrollLeft - deltaX;
          updateScrollbar();
        },
        { signal }
      );

      const endDrag = (event) => {
        if (!isDragging) return;

        isDragging = false;
        rail.classList.remove('is-dragging');
        if (capturedRailPointerId != null && typeof rail.hasPointerCapture === 'function' && rail.hasPointerCapture(capturedRailPointerId)) {
          rail.releasePointerCapture(capturedRailPointerId);
        }
        capturedRailPointerId = null;

        if (moved) {
          blockNextClick = true;
          window.setTimeout(() => {
            blockNextClick = false;
          }, 0);
        }
      };

      rail.addEventListener('pointerup', endDrag, { signal });
      rail.addEventListener('pointercancel', endDrag, { signal });
      rail.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      rail.addEventListener('scroll', updateScrollbar, { signal, passive: true });
      window.addEventListener('resize', updateScrollbar, { signal });
      rail.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', updateScrollbar, { once: true, signal });
      });

      if (scrollbar) {
        scrollbar.addEventListener(
          'pointerdown',
          (event) => {
            if (!isMouseLikePointer(event) || event.button !== 0) return;

            const metrics = getScrollbarMetrics();
            if (!metrics) return;

            const rect = scrollbar.getBoundingClientRect();
            if (event.target !== scrollbarThumb) {
              setRailScrollFromScrollbarOffset(event.clientX - rect.left - metrics.thumbWidth / 2);
            }

            isScrollbarDragging = true;
            scrollbarStartX = event.clientX;
            scrollbarStartScrollLeft = rail.scrollLeft;
            scrollbar.classList.add('is-dragging');
            event.preventDefault();

            if (typeof scrollbar.setPointerCapture === 'function') {
              scrollbar.setPointerCapture(event.pointerId);
            }
          },
          { signal }
        );

        scrollbar.addEventListener(
          'pointermove',
          (event) => {
            if (!isScrollbarDragging) return;

            const metrics = getScrollbarMetrics();
            if (!metrics) return;

            const deltaX = event.clientX - scrollbarStartX;
            rail.scrollLeft = scrollbarStartScrollLeft + (deltaX / metrics.maxThumbOffset) * metrics.scrollableWidth;
            updateScrollbar();
            event.preventDefault();
          },
          { signal }
        );

        const endScrollbarDrag = (event) => {
          if (!isScrollbarDragging) return;

          isScrollbarDragging = false;
          scrollbar.classList.remove('is-dragging');
          if (event && typeof scrollbar.hasPointerCapture === 'function' && scrollbar.hasPointerCapture(event.pointerId)) {
            scrollbar.releasePointerCapture(event.pointerId);
          }
        };

        scrollbar.addEventListener('pointerup', endScrollbarDrag, { signal });
        scrollbar.addEventListener('pointercancel', endScrollbarDrag, { signal });
      }

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(updateScrollbar);
        ro.observe(rail);
        if (scrollbar) ro.observe(scrollbar);
        signal.addEventListener('abort', () => ro.disconnect(), { once: true });
      }

      rail.addEventListener(
        'click',
        (event) => {
          if (!blockNextClick) return;
          event.preventDefault();
          event.stopPropagation();
          blockNextClick = false;
        },
        { capture: true, signal }
      );

      requestAnimationFrame(updateScrollbar);
    };

    const bindAll = (root = document) => {
      root.querySelectorAll('.pi2-more-designs__rail').forEach(bindRail);
    };

    bindAll();
    document.addEventListener('shopify:section:load', (event) => bindAll(event.target), { signal });
    document.addEventListener('shopify:section:unload', () => controller.abort(), { once: true, signal });

    window[bindingKey] = {
      controller,
      cleanup: () => controller.abort(),
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seacore-product-hero"] && !Shopify.designMode) return;
  try {
    
  class SeacoreProductHero extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;

      this.mainImage = this.querySelector('img.seacore-product-hero__main-image');
      this.stage = this.querySelector('.seacore-product-hero__main');
      this.hoverZoom = this.querySelector('[data-seacore-hero-hover-zoom]');
      this.hoverZoomMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.mobileGalleryMedia = window.matchMedia('(max-width: 749px) and (hover: none)');
      this.reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hoverZoomActive = false;
      this.hoverZoomPoint = null;
      this.hoverZoomRequest = 0;
      this.mobileAutoplayTimer = null;
      this.galleryVisible = true;
      this.thumbButtons = Array.from(this.querySelectorAll('[data-seacore-hero-thumb]'));
      this.mobileZoomTrigger = this.querySelector('[data-seacore-hero-mobile-zoom]');
      this.mobileLightbox = this.querySelector('[data-seacore-hero-mobile-lightbox]');
      this.mobileLightboxImage = this.querySelector('[data-seacore-hero-mobile-lightbox-image]');
      this.mobileLightboxClose = this.querySelector('[data-seacore-hero-mobile-lightbox-close]');
      this.optionsContainer = this.querySelector('[data-seacore-hero-options]');
      this.optionGroups = Array.from(this.querySelectorAll('[data-seacore-hero-option-group]')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
      this.availabilityEl = this.querySelector('[data-seacore-hero-availability]');
      this.button = this.querySelector('[data-seacore-hero-button]');
      this.variantIdInput = this.querySelector('[data-seacore-hero-variant-id]');
      this.quantityInput = this.querySelector('[data-seacore-hero-quantity]');
      this.currentVariant = null;
      this.addToCartContainer = this.querySelector('[data-seacore-hero-add-to-cart]');
      this.variantsEl = this.querySelector('[data-seacore-hero-variants]');
      this.initialVariantId = this.dataset.initialVariantId || '';
      this.variants = this.parseVariants();
      this.currentImage = this.readMainImage();

      this.onThumbClick = this.onThumbClick.bind(this);
      this.onOptionClick = this.onOptionClick.bind(this);
      this.onQuantityChange = this.onQuantityChange.bind(this);
      this.onStagePointerEnter = this.onStagePointerEnter.bind(this);
      this.onStagePointerMove = this.onStagePointerMove.bind(this);
      this.onStagePointerLeave = this.onStagePointerLeave.bind(this);
      this.onMobileZoomClick = this.openMobileLightbox.bind(this);
      this.onMobileLightboxClose = this.closeMobileLightbox.bind(this);
      this.onMobileLightboxBackdrop = this.handleMobileLightboxBackdrop.bind(this);
      this.onMobileLightboxClosed = this.updateMobileAutoplay.bind(this);
      this.onMobileGalleryMediaChange = this.updateMobileAutoplay.bind(this);
      this.onVisibilityChange = this.updateMobileAutoplay.bind(this);

      this.thumbButtons.forEach((button) => button.addEventListener('click', this.onThumbClick));
      this.mobileZoomTrigger?.addEventListener('click', this.onMobileZoomClick);
      this.mobileLightboxClose?.addEventListener('click', this.onMobileLightboxClose);
      this.mobileLightbox?.addEventListener('click', this.onMobileLightboxBackdrop);
      this.mobileLightbox?.addEventListener('close', this.onMobileLightboxClosed);
      this.mobileGalleryMedia?.addEventListener('change', this.onMobileGalleryMediaChange);
      this.reducedMotionMedia?.addEventListener('change', this.onMobileGalleryMediaChange);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.optionsContainer?.addEventListener('click', this.onOptionClick);
      this.addEventListener('input', this.onQuantityChange);
      this.addEventListener('change', this.onQuantityChange);
      this.stage?.addEventListener('pointerenter', this.onStagePointerEnter);
      this.stage?.addEventListener('pointermove', this.onStagePointerMove);
      this.stage?.addEventListener('pointerleave', this.onStagePointerLeave);

      if (this.stage && 'IntersectionObserver' in window) {
        this.galleryObserver = new IntersectionObserver(([entry]) => {
          this.galleryVisible = Boolean(entry?.isIntersecting);
          this.updateMobileAutoplay();
        }, { threshold: 0.2 });
        this.galleryObserver.observe(this.stage);
      }

      this.prepareHoverZoom(this.currentImage?.zoomSrc);
      this.syncThumbActive(this.currentImage?.imageId);
      this.ensureOptionSelection();

      if (this.variants.length) {
        this.syncVariant(this.getInitialVariant(), { updateUrl: true });
        this.updateOptionAvailability();
      }

      this.updateMobileAutoplay();
    }

    disconnectedCallback() {
      this.thumbButtons?.forEach((button) => button.removeEventListener('click', this.onThumbClick));
      this.mobileZoomTrigger?.removeEventListener('click', this.onMobileZoomClick);
      this.mobileLightboxClose?.removeEventListener('click', this.onMobileLightboxClose);
      this.mobileLightbox?.removeEventListener('click', this.onMobileLightboxBackdrop);
      this.mobileLightbox?.removeEventListener('close', this.onMobileLightboxClosed);
      this.mobileGalleryMedia?.removeEventListener('change', this.onMobileGalleryMediaChange);
      this.reducedMotionMedia?.removeEventListener('change', this.onMobileGalleryMediaChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.optionsContainer?.removeEventListener('click', this.onOptionClick);
      this.removeEventListener('input', this.onQuantityChange);
      this.removeEventListener('change', this.onQuantityChange);
      this.stage?.removeEventListener('pointerenter', this.onStagePointerEnter);
      this.stage?.removeEventListener('pointermove', this.onStagePointerMove);
      this.stage?.removeEventListener('pointerleave', this.onStagePointerLeave);
      this.galleryObserver?.disconnect();
      this.stopMobileAutoplay();
      this.hideHoverZoom();
      this.isInitialized = false;
    }

    parseVariants() {
      if (!this.variantsEl) return [];

      try {
        const data = JSON.parse(this.variantsEl.textContent || '[]');
        return Array.isArray(data) ? data : [];
      } catch (error) {
        return [];
      }
    }

    readMainImage() {
      if (!this.mainImage) return null;

      return {
        src: this.mainImage.currentSrc || this.mainImage.src,
        zoomSrc: this.mainImage.dataset.zoomSrc || this.mainImage.currentSrc || this.mainImage.src,
        alt: this.mainImage.alt || '',
        imageId: this.mainImage.dataset.imageId || ''
      };
    }

    onThumbClick(event) {
      const button = event.currentTarget;
      const src = button?.dataset.imageSrc;
      if (!src || !this.mainImage) return;

      this.setMainImage({
        src,
        zoomSrc: button.dataset.imageZoomSrc || src,
        alt: button.dataset.imageAlt || '',
        imageId: button.dataset.imageId || ''
      });
      this.updateMobileAutoplay();
    }

    showNextMobileImage() {
      if (this.thumbButtons.length < 2) return;

      const currentIndex = this.thumbButtons.findIndex(
        (button) => button.getAttribute('aria-current') === 'true'
      );
      const nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % this.thumbButtons.length;
      const button = this.thumbButtons[nextIndex];
      const src = button?.dataset.imageSrc;
      if (!src) return;

      this.setMainImage({
        src,
        zoomSrc: button.dataset.imageZoomSrc || src,
        alt: button.dataset.imageAlt || '',
        imageId: button.dataset.imageId || ''
      });

      button.closest('.seacore-product-hero__thumb')?.scrollIntoView({
        behavior: this.reducedMotionMedia?.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }

    updateMobileAutoplay() {
      this.stopMobileAutoplay();

      if (
        !this.mobileGalleryMedia?.matches ||
        this.reducedMotionMedia?.matches ||
        this.thumbButtons.length < 2 ||
        !this.galleryVisible ||
        document.hidden ||
        this.mobileLightbox?.open
      ) {
        return;
      }

      this.mobileAutoplayTimer = window.setInterval(() => this.showNextMobileImage(), 5000);
    }

    stopMobileAutoplay() {
      if (this.mobileAutoplayTimer == null) return;
      window.clearInterval(this.mobileAutoplayTimer);
      this.mobileAutoplayTimer = null;
    }

    openMobileLightbox(event) {
      event?.preventDefault();
      if (!this.mobileGalleryMedia?.matches || !this.mobileLightbox || !this.mobileLightboxImage) return;

      const source =
        this.mainImage?.dataset.zoomSrc ||
        this.mainImage?.currentSrc ||
        this.mainImage?.src;
      if (!source) return;

      this.stopMobileAutoplay();
      this.mobileLightboxImage.src = source;
      this.mobileLightboxImage.alt = this.mainImage?.alt || '';

      if (typeof this.mobileLightbox.showModal === 'function') {
        if (!this.mobileLightbox.open) this.mobileLightbox.showModal();
      } else {
        this.mobileLightbox.setAttribute('open', '');
      }
    }

    closeMobileLightbox() {
      if (!this.mobileLightbox) return;

      if (typeof this.mobileLightbox.close === 'function' && this.mobileLightbox.open) {
        this.mobileLightbox.close();
      } else {
        this.mobileLightbox.removeAttribute('open');
        this.updateMobileAutoplay();
      }
    }

    handleMobileLightboxBackdrop(event) {
      if (event.target === this.mobileLightbox) this.closeMobileLightbox();
    }

    setMainImage(image) {
      if (!this.mainImage || !image?.src) return;

      this.hideHoverZoom();
      this.mainImage.removeAttribute('srcset');
      this.mainImage.removeAttribute('sizes');
      this.mainImage.src = image.src;
      this.mainImage.alt = image.alt || '';
      this.mainImage.dataset.imageId = image.imageId || '';
      this.mainImage.dataset.zoomSrc = image.zoomSrc || image.src;

      this.currentImage = {
        src: image.src,
        zoomSrc: image.zoomSrc || image.src,
        alt: image.alt || '',
        imageId: image.imageId || ''
      };

      this.prepareHoverZoom(this.currentImage.zoomSrc);
      this.syncThumbActive(this.currentImage.imageId);
    }

    syncThumbActive(imageId) {
      const normalized = imageId == null ? '' : String(imageId).trim();
      if (!normalized) return;

      this.thumbButtons.forEach((button) => {
        const isActive = String(button.dataset.imageId || '') === normalized;
        button.closest('.seacore-product-hero__thumb')?.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    onOptionClick(event) {
      const button = event.target.closest?.('[data-seacore-hero-option-value]');
      const group = button?.closest('[data-seacore-hero-option-group]');
      if (!button || !group || button.disabled) return;

      group.querySelectorAll('[data-seacore-hero-option-value]').forEach((optionButton) => {
        const isSelected = optionButton === button;
        optionButton.classList.toggle('is-selected', isSelected);
        optionButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      this.updateOptionValueLabels();
      this.syncVariant(this.findVariant(this.getSelectedOptions()), { updateUrl: true });
      this.updateOptionAvailability();
    }

    ensureOptionSelection() {
      this.optionGroups.forEach((group) => {
        if (group.querySelector('[data-seacore-hero-option-value].is-selected')) return;

        const fallback =
          group.querySelector('[data-seacore-hero-option-value]:not(:disabled)') ||
          group.querySelector('[data-seacore-hero-option-value]');

        if (fallback) {
          fallback.classList.add('is-selected');
          fallback.setAttribute('aria-pressed', 'true');
        }
      });

      this.updateOptionValueLabels();
    }

    getOptionPositions() {
      const positions = new Set();

      this.optionGroups.forEach((group) => positions.add(Number(group.dataset.optionPosition)));

      return Array.from(positions).sort((a, b) => a - b);
    }

    getSelectedOptions() {
      const selected = new Map();

      this.optionGroups.forEach((group) => {
        const active = group.querySelector('[data-seacore-hero-option-value].is-selected');
        if (active) {
          selected.set(
            Number(group.dataset.optionPosition),
            this.normalizeOption(active.dataset.optionValue)
          );
        }
      });

      return Array.from(selected.keys())
        .sort((a, b) => a - b)
        .map((position) => selected.get(position));
    }

    updateOptionValueLabels() {
      this.optionGroups.forEach((group) => {
        const active = group.querySelector('[data-seacore-hero-option-value].is-selected');
        const value = group.querySelector('[data-seacore-hero-selected-value]');
        if (!value) return;
        value.textContent = active?.dataset.optionLabel || active?.dataset.optionValue || '';
      });
    }

    updateOptionAvailability() {
      if (!this.optionGroups.length || !this.variants.length) return;

      const positions = this.getOptionPositions();
      const selected = this.getSelectedOptions();
      const soldOutLabel = this.dataset.labelSoldOut || '';

      this.optionGroups.forEach((group) => {
        const index = positions.indexOf(Number(group.dataset.optionPosition));

        group.querySelectorAll('[data-seacore-hero-option-value]').forEach((button) => {
          const candidate = selected.slice();
          if (index > -1) candidate[index] = this.normalizeOption(button.dataset.optionValue);

          const variant = this.findVariant(candidate);
          const unavailable = !variant;
          const soldOut = Boolean(variant && variant.available === false);
          const label = button.dataset.optionLabel || button.textContent.trim();

          button.disabled = unavailable;
          button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
          button.classList.toggle('is-unavailable', unavailable);
          button.classList.toggle('is-sold-out', soldOut);

          if (soldOut && soldOutLabel) {
            button.setAttribute('aria-label', `${label} — ${soldOutLabel}`);
          } else {
            button.removeAttribute('aria-label');
          }
        });
      });
    }

    normalizeOption(value) {
      // Liquid and the variant JSON can differ in whitespace around an option
      // value. Normalize that boundary before comparing values so a valid
      // variant is never treated as unavailable just because of formatting.
      return String(value == null ? '' : value)
        .replace(/\s+/g, ' ')
        .trim();
    }

    findVariant(values) {
      const selected = values.map((value) => this.normalizeOption(value));

      return (
        this.variants.find((variant) => {
          if (!variant || !Array.isArray(variant.options)) return false;

          return (
            variant.options.length === selected.length &&
            variant.options.every(
              (value, index) => this.normalizeOption(value) === selected[index]
            )
          );
        }) || null
      );
    }

    findVariantById(id) {
      const target = String(id || '');
      if (!target) return null;

      return this.variants.find((variant) => String(variant.id) === target) || null;
    }

    getInitialVariant() {
      // `selected_value` is not guaranteed to be populated consistently when
      // a product page is rendered with a `?variant=` URL. The server-provided
      // variant id is authoritative, so use it before reconstructing a variant
      // from the option buttons.
      const initialVariant = this.findVariantById(this.initialVariantId);
      if (initialVariant) return initialVariant;

      if (this.getOptionPositions().length) {
        const selectedVariant = this.findVariant(this.getSelectedOptions());
        if (selectedVariant) return selectedVariant;
      }

      return this.variants.find((variant) => variant?.available) || this.variants[0] || null;
    }

    syncSelectedOptions(variant) {
      if (!variant || !Array.isArray(variant.options)) return;

      const positions = this.getOptionPositions();
      this.optionGroups.forEach((group) => {
        const optionIndex = positions.indexOf(Number(group.dataset.optionPosition));
        if (optionIndex < 0) return;

        const value = this.normalizeOption(variant.options[optionIndex]);
        group.querySelectorAll('[data-seacore-hero-option-value]').forEach((button) => {
          const isSelected = this.normalizeOption(button.dataset.optionValue) === value;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      });

      this.updateOptionValueLabels();
    }

    setButtonLabel(text) {
      const button = this.querySelector('[data-seacore-hero-button]') || this.button;
      if (!button) return;

      this.button = button;
      button.textContent = text;
    }

    onQuantityChange(event) {
      if (!(event.target instanceof Element)) return;
      if (!event.target.matches('[data-seacore-hero-quantity]')) return;

      this.quantityInput = event.target;
      this.updateButtonPrice();
    }

    formatMoney(cents) {
      const format =
        this.dataset.moneyFormat || `${this.dataset.currencySymbol || ''}{{amount}}`;
      const value = Number(cents) || 0;

      const formatAmount = (decimals, thousandsSeparator, decimalSeparator) => {
        const fixed = (value / 100).toFixed(decimals);
        const [whole, fraction] = fixed.split('.');
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
        return decimals > 0 ? `${grouped}${decimalSeparator}${fraction}` : grouped;
      };

      const formatted = format
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, formatAmount(0, '.', ''))
        .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, formatAmount(0, ' ', ''))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, formatAmount(0, ',', ''))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatAmount(2, '.', ','))
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatAmount(2, "'", '.'))
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, formatAmount(2, ' ', ','))
        .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, formatAmount(2, ' ', '.'))
        .replace(/\{\{\s*amount\s*\}\}/g, formatAmount(2, ',', '.'));

      if (/\{\{\s*amount/.test(formatted)) {
        return `${this.dataset.currencySymbol || ''}${formatAmount(2, ',', '.')}`;
      }

      return formatted;
    }

    updateButtonPrice() {
      const variant = this.currentVariant;
      if (!variant) {
        this.setButtonLabel(this.dataset.labelUnavailable || 'Unavailable');
        return;
      }

      const quantity = Math.max(1, parseInt(this.quantityInput?.value, 10) || 1);
      const unitAmount = Number(variant.price_amount);
      const totalAmount = Number.isFinite(unitAmount) ? unitAmount * quantity : null;
      const priceText = totalAmount === null ? variant.price || '' : this.formatMoney(totalAmount);
      const label = variant.available
        ? this.dataset.labelAvailable || 'Add to cart'
        : this.dataset.labelSoldOut || 'Sold out';

      this.setButtonLabel(priceText ? `${label} - ${priceText}` : label);
    }

    syncVariant(variant, options = {}) {
      const updateUrl = options.updateUrl !== false;

      this.availabilityEl = this.querySelector('[data-seacore-hero-availability]') || this.availabilityEl;
      this.button = this.querySelector('[data-seacore-hero-button]') || this.button;
      this.variantIdInput = this.querySelector('[data-seacore-hero-variant-id]') || this.variantIdInput;
      this.quantityInput = this.querySelector('[data-seacore-hero-quantity]') || this.quantityInput;
      this.addToCartContainer =
        this.querySelector('[data-seacore-hero-add-to-cart]') || this.addToCartContainer;

      if (!variant) {
        this.currentVariant = null;
        this.dataset.variantId = '';
        if (this.variantIdInput) this.variantIdInput.value = '';
        if (this.availabilityEl) {
          this.availabilityEl.textContent = this.dataset.labelUnavailable || 'Unavailable';
        }
        if (this.button) {
          this.button.disabled = true;
        }
        this.updateButtonPrice();
        if (updateUrl) this.updateVariantUrl(null);
        return;
      }

      this.currentVariant = variant;
      this.dataset.variantId = String(variant.id);
      if (this.variantIdInput) this.variantIdInput.value = variant.id;

      // Keep the controls and the variant used for pricing/submission in sync
      // when initialization came from a variant id rather than a button click.
      this.syncSelectedOptions(variant);

      if (this.availabilityEl) {
        this.availabilityEl.textContent = variant.available
          ? ''
          : this.dataset.labelSoldOut || 'Sold out';
      }

      if (this.button) {
        this.button.disabled = !variant.available;
      }
      this.updateButtonPrice();

      if (variant.image_src) {
        this.setMainImage({
          src: variant.image_src,
          zoomSrc: variant.image_zoom_src || variant.image_src,
          alt: variant.image_alt || '',
          imageId: variant.image_id || ''
        });

        if (this.addToCartContainer) {
          this.addToCartContainer.dataset.productVariantMedia = variant.image_src;
        }
      }

      if (updateUrl) this.updateVariantUrl(variant.id);
    }

    updateVariantUrl(id) {
      if (this.isDesignMode()) return;

      const url = new URL(window.location.href);
      if (id) url.searchParams.set('variant', id);
      else url.searchParams.delete('variant');
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }

    isDesignMode() {
      return (
        Boolean(window.Shopify?.designMode) ||
        document.documentElement.classList.contains('shopify-design-mode')
      );
    }

    onStagePointerEnter(event) {
      if (!this.hoverZoomMedia?.matches || event.pointerType === 'touch') return;
      this.hoverZoomActive = true;
      this.updateHoverZoom(event);
    }

    onStagePointerMove(event) {
      if (!this.hoverZoomActive) return;
      this.updateHoverZoom(event);
    }

    onStagePointerLeave() {
      this.hideHoverZoom();
    }

    updateHoverZoom(event) {
      if (!this.stage || !this.hoverZoom || !this.mainImage) return;

      const zoomSource = this.mainImage.dataset.zoomSrc || this.mainImage.currentSrc || this.mainImage.src;
      if (!zoomSource) return;

      this.hoverZoomPoint = { x: event.clientX, y: event.clientY };

      if (
        this.hoverZoom.dataset.zoomSource !== zoomSource ||
        !this.hoverZoom.complete ||
        this.hoverZoom.naturalWidth <= 0
      ) {
        this.prepareHoverZoom(zoomSource);
        return;
      }

      if (this.hoverZoom.complete && this.hoverZoom.naturalWidth > 0) {
        this.positionHoverZoom();
      }
    }

    prepareHoverZoom(zoomSource) {
      if (!this.hoverZoom) return;

      const source = zoomSource || '';
      const request = ++this.hoverZoomRequest;
      this.hoverZoom.classList.remove('is-ready');
      this.hoverZoom.onload = null;
      this.hoverZoom.onerror = null;
      this.hoverZoom.dataset.zoomSource = source;

      if (!source) {
        this.hoverZoom.removeAttribute('src');
        return;
      }

      const revealZoom = () => {
        if (
          request !== this.hoverZoomRequest ||
          !this.hoverZoomActive ||
          this.hoverZoom?.dataset.zoomSource !== source ||
          !this.hoverZoom.naturalWidth
        ) {
          return;
        }
        this.positionHoverZoom();
      };

      this.hoverZoom.onload = revealZoom;
      this.hoverZoom.onerror = () => {
        if (request !== this.hoverZoomRequest) return;

        const fallbackSource = this.currentImage?.src || this.mainImage?.src || '';
        if (fallbackSource && fallbackSource !== source) {
          this.mainImage.dataset.zoomSrc = fallbackSource;
          this.currentImage.zoomSrc = fallbackSource;
          this.prepareHoverZoom(fallbackSource);
          return;
        }

        this.hoverZoom.dataset.zoomSource = '';
        this.hideHoverZoom();
      };
      this.hoverZoom.src = source;

      if (this.hoverZoom.complete && this.hoverZoom.naturalWidth > 0) {
        revealZoom();
      } else if (typeof this.hoverZoom.decode === 'function') {
        this.hoverZoom.decode().then(revealZoom).catch(() => {});
      }
    }

    positionHoverZoom() {
      if (!this.stage || !this.hoverZoom || !this.hoverZoomPoint) return;

      const rect = this.stage.getBoundingClientRect();
      const naturalWidth = this.hoverZoom.naturalWidth;
      const naturalHeight = this.hoverZoom.naturalHeight;
      if (!rect.width || !rect.height || !naturalWidth || !naturalHeight) return;

      const imageRatio = naturalWidth / naturalHeight;
      const stageRatio = rect.width / rect.height;
      let fittedWidth = rect.width;
      let fittedHeight = rect.height;

      if (imageRatio > stageRatio) {
        fittedWidth = fittedHeight * imageRatio;
      } else {
        fittedHeight = fittedWidth / imageRatio;
      }

      const offsetX = (rect.width - fittedWidth) / 2;
      const offsetY = (rect.height - fittedHeight) / 2;
      const pointerX = Math.min(fittedWidth, Math.max(0, this.hoverZoomPoint.x - rect.left - offsetX));
      const pointerY = Math.min(fittedHeight, Math.max(0, this.hoverZoomPoint.y - rect.top - offsetY));
      const progressX = fittedWidth ? pointerX / fittedWidth : 0.5;
      const progressY = fittedHeight ? pointerY / fittedHeight : 0.5;
      const zoomWidth = Math.max(naturalWidth, fittedWidth);
      const zoomHeight = Math.max(naturalHeight, fittedHeight);

      this.hoverZoom.style.width = `${zoomWidth}px`;
      this.hoverZoom.style.height = `${zoomHeight}px`;
      this.hoverZoom.style.left = `${offsetX - progressX * (zoomWidth - fittedWidth)}px`;
      this.hoverZoom.style.top = `${offsetY - progressY * (zoomHeight - fittedHeight)}px`;
      this.hoverZoom.classList.add('is-ready');
    }

    hideHoverZoom() {
      this.hoverZoomActive = false;
      this.hoverZoomPoint = null;
      this.hoverZoom?.classList.remove('is-ready');
    }
  }

  if (!customElements.get('seacore-product-hero')) {
    customElements.define('seacore-product-hero', SeacoreProductHero);
  }

  if (!window.seacoreProductOptionValueSyncBound) {
    window.seacoreProductOptionValueSyncBound = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest?.(
        'seacore-product-hero [data-seacore-hero-option-value]'
      );
      if (!button || button.disabled) return;

      const group = button.closest('[data-seacore-hero-option-group]');
      const value = group?.querySelector('[data-seacore-hero-selected-value]');
      if (value) value.textContent = button.dataset.optionLabel || button.dataset.optionValue || '';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seacube-JM-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const TAG_NAME = 'seacube-sticky-cart';
    if (customElements.get(TAG_NAME)) return;

    class SeaCubeStickyCart extends HTMLElement {
      connectedCallback() {
        this.main = document.querySelector(
          'seacube-product-main[data-product-id="' + this.dataset.productId + '"]'
        );
        this.buyForm = this.main?.querySelector('[data-sc-form]');
        this.targetButton = this.main?.querySelector('[data-sc-atc]');
        this.targetButtonText = this.main?.querySelector('[data-sc-atc-text]');
        this.image = this.querySelector('[data-sc-sticky-image]');
        this.price = this.querySelector('[data-sc-sticky-price]');
        this.comparePrice = this.querySelector('[data-sc-sticky-compare]');
        this.variantTitle = this.querySelector('[data-sc-sticky-variant]');
        this.stickyButton = this.querySelector('[data-sc-sticky-atc]');
        this.stickyButtonText = this.querySelector('[data-sc-sticky-atc-text]');
        this.dialog = this.querySelector('[data-sc-sticky-dialog]');
        this.dialogOptions = this.querySelector('[data-sc-sticky-options]');
        this.dialogImage = this.querySelector('[data-sc-dialog-image]');
        this.dialogSelected = this.querySelector('[data-sc-dialog-selected]');
        this.dialogPrice = this.querySelector('[data-sc-dialog-price]');
        this.dialogCompare = this.querySelector('[data-sc-dialog-compare]');
        this.dialogSubmit = this.querySelector('[data-sc-dialog-submit]');
        this.dialogSubmitText = this.querySelector('[data-sc-dialog-submit-text]');
        this.abortController = new AbortController();
        this.isAdding = false;

        if (!this.main || !this.buyForm || !this.targetButton || !this.stickyButton) return;

        this.variants = this.main.variants || this.readVariants();
        this.optionGroups = this.readOptionGroups();
        this.observer = new IntersectionObserver(this.handleBuyFormIntersection, { threshold: 0 });
        this.observer.observe(this.buyForm);
        this.main.addEventListener('seacube:variant-changed', this.handleVariantChanged, {
          signal: this.abortController.signal,
        });
        this.stickyButton.addEventListener('click', this.openOptions, {
          signal: this.abortController.signal,
        });
        this.dialogOptions?.addEventListener('click', this.handleOptionClick, {
          signal: this.abortController.signal,
        });
        this.dialogSubmit?.addEventListener('click', this.addSelectedToCart, {
          signal: this.abortController.signal,
        });
        this.dialog?.addEventListener('click', this.handleDialogClick, {
          signal: this.abortController.signal,
        });
        this.dialog?.addEventListener('cancel', this.closeOptions, {
          signal: this.abortController.signal,
        });
        this.targetButtonObserver = new MutationObserver(this.syncButton);
        this.targetButtonObserver.observe(this.targetButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        this.syncFromMain();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.targetButtonObserver?.disconnect();
        this.abortController?.abort();
      }

      readVariants() {
        const element = this.main?.querySelector('[data-sc-variants]');
        if (!element) return [];
        try {
          const variants = JSON.parse(element.textContent || '[]');
          return Array.isArray(variants) ? variants : [];
        } catch (error) {
          console.error('[SeaCube] Unable to parse sticky cart variants.', error);
          return [];
        }
      }

      readOptionGroups() {
        return Array.from(this.main.querySelectorAll('[data-sc-option-group]')).map((group) => ({
          index: Number(group.dataset.scOptionGroup),
          label: group.querySelector('.sc-product__option-label')?.textContent.trim() || 'Style',
          visual: Boolean(group.querySelector('[data-sc-option] .sc-product__swatch-media')),
          values: Array.from(group.querySelectorAll('[data-sc-option]')).map((button) => ({
            value: button.dataset.value || '',
          })),
        }));
      }

      normalize(value) {
        return String(value == null ? '' : value).trim().toLowerCase();
      }

      findVariant(options) {
        return this.variants.find(
          (variant) =>
            Array.isArray(variant.options) &&
            options.length === variant.options.length &&
            options.every(
              (value, index) => this.normalize(value) === this.normalize(variant.options[index])
            )
        );
      }

      isPurchasable(variant) {
        if (!variant || !variant.available) return false;
        const rule = variant.quantity_rule || {};
        if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
          const minimum = Number(rule.min) || 1;
          const inventory = Number(variant.inventory_quantity);
          if (!Number.isNaN(inventory) && minimum > inventory) return false;
        }
        return true;
      }

      hasPurchasableOption(groupIndex, value) {
        const selected = this.pendingOptions.slice();
        selected[groupIndex] = value;
        return this.variants.some(
          (variant) =>
            Array.isArray(variant.options) &&
            selected.every(
              (option, index) => this.normalize(option) === this.normalize(variant.options[index])
            ) &&
            this.isPurchasable(variant)
        );
      }

      variantImage(variant) {
        if (!variant) return null;
        const media = variant.media_id
          ? this.main.querySelector(
              '[data-sc-slide][data-media-id="' + String(variant.media_id) + '"] img'
            )
          : this.main.querySelector('[data-sc-slide].is-active img');
        return media || null;
      }

      handleBuyFormIntersection = ([entry]) => {
        if (!entry) return;
        const rect = entry.target.getBoundingClientRect();
        const isAboveViewport = !entry.isIntersecting && rect.bottom <= 0;
        this.classList.toggle('is-visible', isAboveViewport);
        this.setAttribute('aria-hidden', isAboveViewport ? 'false' : 'true');
      };

      openOptions = () => {
        if (!this.dialog || !this.variants.length) return;
        this.pendingVariant = this.main.currentVariant || this.variants[0];
        this.pendingOptions = Array.isArray(this.pendingVariant.options)
          ? this.pendingVariant.options.slice()
          : [];
        this.renderOptions();
        if (typeof this.dialog.showModal === 'function') {
          if (!this.dialog.open) this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      };

      closeOptions = () => {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
        else this.dialog.removeAttribute('open');
      };

      handleDialogClick = (event) => {
        if (event.target === this.dialog || event.target.closest?.('[data-sc-sticky-close]')) {
          event.preventDefault();
          this.closeOptions();
        }
      };

      handleOptionClick = (event) => {
        const option = event.target.closest('[data-sc-dialog-option]');
        if (!option || option.disabled) return;

        const index = Number(option.dataset.optionIndex);
        const value = option.dataset.optionValue || '';
        const nextOptions = this.pendingOptions.slice();
        nextOptions[index] = value;
        let variant = this.findVariant(nextOptions);
        if (!variant) {
          const candidates = this.variants.filter(
            (candidate) => this.normalize(candidate.options[index]) === this.normalize(value)
          );
          variant = candidates.find((candidate) => this.isPurchasable(candidate)) || candidates[0] || null;
        }
        if (!variant) return;

        this.pendingVariant = variant;
        this.pendingOptions = Array.isArray(variant.options) ? variant.options.slice() : nextOptions;
        this.renderOptions();
      };

      renderOptions() {
        if (!this.dialogOptions) return;
        this.dialogOptions.replaceChildren();
        this.optionGroups.forEach((group) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'sc-sticky-cart__option-group';

          const heading = document.createElement('div');
          heading.className = 'sc-sticky-cart__option-heading';
          const label = document.createElement('span');
          label.className = 'sc-sticky-cart__option-label';
          label.textContent = `${group.label}:`;
          const selected = document.createElement('strong');
          selected.className = 'sc-sticky-cart__option-value';
          selected.textContent = this.pendingOptions[group.index] || '';
          heading.append(label, selected);

          const list = document.createElement('div');
          list.className = 'sc-sticky-cart__option-list';
          group.values.forEach(({ value }) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'sc-sticky-cart__option';
            if (group.visual) button.classList.add('sc-sticky-cart__option--image');
            button.dataset.scDialogOption = 'true';
            button.dataset.optionIndex = String(group.index);
            button.dataset.optionValue = value;
            button.setAttribute('aria-label', value);
            button.setAttribute('aria-pressed',
              this.normalize(this.pendingOptions[group.index]) === this.normalize(value) ? 'true' : 'false'
            );
            const isSelected = this.normalize(this.pendingOptions[group.index]) === this.normalize(value);
            button.classList.toggle('is-selected', isSelected);
            button.disabled = !this.hasPurchasableOption(group.index, value);
            button.classList.toggle('is-unavailable', button.disabled);

            if (group.visual) {
              const candidate = this.variants.find(
                (variant) => this.normalize(variant.options[group.index]) === this.normalize(value)
              );
              const image = this.variantImage(candidate);
              if (image?.src) {
                const optionImage = document.createElement('img');
                optionImage.className = 'sc-sticky-cart__option-image';
                optionImage.src = image.currentSrc || image.src;
                optionImage.alt = value;
                optionImage.loading = 'lazy';
                button.append(optionImage);
              } else {
                button.textContent = value;
              }
            } else {
              button.textContent = value;
            }
            list.append(button);
          });
          wrapper.append(heading, list);
          this.dialogOptions.append(wrapper);
        });
        this.renderPendingVariant();
      }

      renderPendingVariant() {
        const variant = this.pendingVariant;
        if (!variant) return;
        if (this.dialogSelected) {
          this.dialogSelected.textContent = this.pendingOptions.join(' / ');
        }
        if (this.dialogPrice) this.dialogPrice.textContent = variant.price_money || '';
        if (this.dialogCompare) {
          const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
          this.dialogCompare.textContent = hasCompare ? variant.compare_at_money || '' : '';
          this.dialogCompare.hidden = !hasCompare;
        }
        const image = this.variantImage(variant);
        if (image && this.dialogImage) {
          this.dialogImage.src = image.currentSrc || image.src;
          this.dialogImage.srcset = image.srcset || '';
          this.dialogImage.alt = image.alt || this.dialogImage.alt;
        }
        if (this.dialogSubmit) {
          this.dialogSubmit.disabled = !this.isPurchasable(variant) || this.isAdding || this.main.isBusy;
          if (this.dialogSubmitText) {
            this.dialogSubmitText.textContent = this.isPurchasable(variant) ? 'Add to cart' : 'Sold out';
          }
        }
      }

      addSelectedToCart = () => {
        if (!this.pendingVariant || !this.isPurchasable(this.pendingVariant) || this.isAdding) return;
        this.main.selected = Array.isArray(this.pendingVariant.options)
          ? this.pendingVariant.options.slice()
          : this.main.selected;
        this.main.applyVariant(this.pendingVariant);
        if (!this.targetButton || this.targetButton.disabled) {
          this.renderPendingVariant();
          return;
        }
        this.isAdding = true;
        if (this.dialogSubmit) this.dialogSubmit.disabled = true;
        if (this.dialogSubmitText) this.dialogSubmitText.textContent = 'Adding...';
        this.closeOptions();
        this.targetButton.click();
        window.setTimeout(() => {
          this.isAdding = false;
          this.renderPendingVariant();
        }, 5000);
      };

      handleVariantChanged = (event) => {
        const variant = event.detail?.variant;
        if (!variant) {
          this.syncButton();
          return;
        }
        this.updateStickyVariant(variant);
        this.syncButton();
      };

      updateStickyVariant(variant) {
        if (this.price) this.price.textContent = variant.price_money || '';
        if (this.comparePrice) {
          const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
          this.comparePrice.textContent = hasCompare ? variant.compare_at_money || '' : '';
          this.comparePrice.hidden = !hasCompare;
        }
        if (this.variantTitle) {
          const title = Array.isArray(variant.options) ? variant.options.join(' / ') : '';
          this.variantTitle.textContent = title === 'Default Title' ? '' : title;
        }
        const image = this.variantImage(variant);
        if (image && this.image) {
          this.image.src = image.currentSrc || image.src;
          this.image.srcset = image.srcset || '';
          this.image.alt = image.alt || this.image.alt;
        }
      }

      syncFromMain() {
        const variant = this.main.currentVariant;
        if (variant) this.updateStickyVariant(variant);
        this.syncButton();
      }

      syncButton = () => {
        if (!this.targetButton || !this.stickyButton) return;
        this.stickyButton.disabled = !this.variants.length || Boolean(this.main.isBusy);
        if (this.stickyButtonText) {
          this.stickyButtonText.textContent = 'Add to cart';
        }
      };
    }

    customElements.define(TAG_NAME, SeaCubeStickyCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seacube-home-content-1"] && !Shopify.designMode) return;
  try {
    
  class SeaCubeBannerStack extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.cards = Array.from(this.querySelectorAll('[data-stack-card]'));
      this.dots = Array.from(this.querySelectorAll('[data-stack-dot]'));
      this.stage = this.querySelector('.seacube-home-banner__stack-stage');
      this.current = 0;
      this.busy = false;
      this.startX = null;
      this.moved = false;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.select(index));
      });

      this.stage?.addEventListener('pointerdown', (event) => {
        this.startX = event.clientX;
        this.moved = false;
      });

      this.stage?.addEventListener('pointerup', (event) => {
        if (this.startX === null) return;
        const distance = event.clientX - this.startX;
        this.startX = null;

        if (this.isMobile()) return;

        if (Math.abs(distance) >= 44) {
          this.moved = true;
          const direction = distance < 0 ? 1 : -1;
          this.select((this.current + direction + this.cards.length) % this.cards.length);
        }
      });

      this.stage?.addEventListener('pointercancel', () => {
        this.startX = null;
      });

      this.stage?.addEventListener(
        'scroll',
        () => {
          if (!this.isMobile()) return;
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => {
            const index = Math.round(this.stage.scrollLeft / this.stage.clientWidth);
            if (this.cards[index]) {
              this.current = index;
              this.update();
            }
          }, 80);
        },
        { passive: true }
      );

      this.stage?.addEventListener('click', (event) => {
        if (this.isMobile() || this.moved || window.Shopify?.designMode) {
          this.moved = false;
          return;
        }

        const clickedCard = event.target.closest('[data-stack-card]');
        if (!clickedCard || this.cards.length < 2) return;

        const clickedIndex = Number(clickedCard.dataset.index);
        if (clickedIndex === this.current) {
          this.select((this.current + 1) % this.cards.length);
        } else {
          this.select(clickedIndex);
        }
      });

      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-stack-card]');
        if (!card) return;
        this.select(Number(card.dataset.index), true);
      });

      this.update();
    }

    disconnectedCallback() {
      window.clearTimeout(this.transitionTimer);
      window.clearTimeout(this.scrollTimer);
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    select(index, instant = false) {
      if (this.busy || index === this.current || !this.cards[index]) return;

      if (this.isMobile()) {
        this.current = index;
        this.update();
        this.stage?.scrollTo({
          left: index * this.stage.clientWidth,
          behavior: instant ? 'auto' : 'smooth',
        });
        return;
      }

      if (instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.current = index;
        this.update();
        return;
      }

      const leavingCard = this.cards[this.current];
      this.busy = true;
      leavingCard?.classList.add('is-leaving');
      this.current = index;

      requestAnimationFrame(() => this.update());

      this.transitionTimer = window.setTimeout(() => {
        leavingCard?.classList.remove('is-leaving');
        this.busy = false;
        this.update();
      }, 580);
    }

    update() {
      const total = this.cards.length;

      this.cards.forEach((card, index) => {
        const relativeIndex = (index - this.current + total) % total;
        const depth = Math.min(relativeIndex, 3);
        card.dataset.depth = String(depth);
        card.dataset.side = relativeIndex % 2 === 0 ? 'left' : 'right';
        card.setAttribute('aria-hidden', String(relativeIndex !== 0));
      });

      this.dots.forEach((dot, index) => {
        const isActive = index === this.current;
        dot.setAttribute('aria-selected', String(isActive));
        dot.tabIndex = isActive ? 0 : -1;
      });
    }
  }

  if (!customElements.get('seacube-banner-stack')) {
    customElements.define('seacube-banner-stack', SeaCubeBannerStack);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seacube-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const TAG_NAME = 'seacube-product-main';
    if (customElements.get(TAG_NAME)) return;

    class SeaCubeProductMain extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-sc-form]');
        this.idInput = this.querySelector('[data-sc-variant-id]');
        this.qtyInput = this.querySelector('[data-sc-qty-input]');
        this.atcButton = this.querySelector('[data-sc-atc]');
        this.atcText = this.querySelector('[data-sc-atc-text]');
        this.feedback = this.querySelector('[data-sc-feedback]');
        this.priceCurrent = this.querySelector('[data-sc-price-current]');
        this.priceCompare = this.querySelector('[data-sc-price-compare]');
        this.variantNote = this.querySelector('[data-sc-variant-note]');
        this.variantRemark = this.querySelector('[data-sc-variant-remark]');
        this.lightbox = this.querySelector('[data-sc-lightbox]');
        this.lightboxImage = this.querySelector('[data-sc-lightbox-img]');
        this.lightboxPrevious = this.querySelector('[data-sc-lightbox-prev]');
        this.lightboxNext = this.querySelector('[data-sc-lightbox-next]');
        this.lightboxCount = this.querySelector('[data-sc-lightbox-count]');
        this.stage = this.querySelector('.sc-product__stage');
        this.hoverZoom = this.querySelector('[data-sc-hover-zoom]');
        this.hoverZoomMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.hoverZoomActive = false;
        this.hoverZoomPoint = null;
        this.lightboxSlides = [];
        this.lightboxIndex = 0;
        this.variants = this.readVariants();
        this.selected = [];
        this.currentVariant = null;
        this.isBusy = false;
        this.feedbackTimer = 0;
        this.addedTimer = 0;
        this.activeMediaId = null;

        if (!this.form || !this.qtyInput || !this.atcButton || !this.variants.length) return;

        this.addEventListener('click', this.handleClick);
        this.form.addEventListener('submit', this.handleSubmit);
        this.qtyInput.addEventListener('change', this.handleQuantityChange);
        this.lightbox?.addEventListener('click', this.handleLightboxClick);
        this.lightbox?.addEventListener('keydown', this.handleLightboxKeydown);
        this.stage?.addEventListener('pointerenter', this.handleStagePointerEnter);
        this.stage?.addEventListener('pointermove', this.handleStagePointerMove);
        this.stage?.addEventListener('pointerleave', this.handleStagePointerLeave);

        const initialId = this.idInput ? String(this.idInput.value) : '';
        const initialVariant =
          this.variants.find((variant) => String(variant.id) === initialId) || this.variants[0];
        this.selected = Array.isArray(initialVariant.options) ? initialVariant.options.slice() : [];
        this.applyVariant(initialVariant, { updateUrl: false });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.form?.removeEventListener('submit', this.handleSubmit);
        this.qtyInput?.removeEventListener('change', this.handleQuantityChange);
        this.lightbox?.removeEventListener('click', this.handleLightboxClick);
        this.lightbox?.removeEventListener('keydown', this.handleLightboxKeydown);
        this.stage?.removeEventListener('pointerenter', this.handleStagePointerEnter);
        this.stage?.removeEventListener('pointermove', this.handleStagePointerMove);
        this.stage?.removeEventListener('pointerleave', this.handleStagePointerLeave);
        this.hideHoverZoom();
        window.clearTimeout(this.feedbackTimer);
        window.clearTimeout(this.addedTimer);
      }

      readVariants() {
        const dataElement = this.querySelector('[data-sc-variants]');
        if (!dataElement) return [];
        try {
          const parsed = JSON.parse(dataElement.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.error('[SeaCube] Unable to parse variant data.', error);
          return [];
        }
      }

      normalize(value) {
        return String(value == null ? '' : value).trim().toLowerCase();
      }

      matchVariants(options) {
        return this.variants.filter(
          (variant) =>
            Array.isArray(variant.options) &&
            options.every((value, index) => this.normalize(variant.options[index]) === this.normalize(value))
        );
      }

      findVariant(options) {
        return this.matchVariants(options)[0] || null;
      }

      handleStagePointerEnter = (event) => {
        if (!this.hoverZoomMedia?.matches || event.pointerType === 'touch') return;
        this.hoverZoomActive = true;
        this.updateHoverZoom(event);
      };

      handleStagePointerMove = (event) => {
        if (!this.hoverZoomActive) return;
        this.updateHoverZoom(event);
      };

      handleStagePointerLeave = () => {
        this.hideHoverZoom();
      };

      updateHoverZoom(event) {
        if (!this.stage || !this.hoverZoom) return;

        const activeSlide = this.querySelector('[data-sc-slide].is-active');
        const zoomSource = activeSlide?.dataset.zoomSrc;
        if (!zoomSource) return;

        this.hoverZoomPoint = { x: event.clientX, y: event.clientY };

        if (this.hoverZoom.dataset.zoomSource !== zoomSource) {
          this.hoverZoom.classList.remove('is-ready');
          this.stage.classList.remove('is-magnifying');
          this.hoverZoom.dataset.zoomSource = zoomSource;
          this.hoverZoom.onload = () => {
            if (!this.hoverZoomActive || this.hoverZoom?.dataset.zoomSource !== zoomSource) return;
            this.positionHoverZoom();
          };
          this.hoverZoom.onerror = () => this.hideHoverZoom();
          this.hoverZoom.src = zoomSource;
          return;
        }

        if (this.hoverZoom.complete && this.hoverZoom.naturalWidth > 0) {
          this.positionHoverZoom();
        }
      }

      positionHoverZoom() {
        if (!this.stage || !this.hoverZoom || !this.hoverZoomPoint) return;

        const rect = this.stage.getBoundingClientRect();
        const naturalWidth = this.hoverZoom.naturalWidth;
        const naturalHeight = this.hoverZoom.naturalHeight;
        if (!rect.width || !rect.height || !naturalWidth || !naturalHeight) return;

        const imageRatio = naturalWidth / naturalHeight;
        const stageRatio = rect.width / rect.height;
        let fittedWidth = rect.width;
        let fittedHeight = rect.height;

        if (imageRatio > stageRatio) {
          fittedHeight = fittedWidth / imageRatio;
        } else {
          fittedWidth = fittedHeight * imageRatio;
        }

        const offsetX = (rect.width - fittedWidth) / 2;
        const offsetY = (rect.height - fittedHeight) / 2;
        const pointerX = Math.min(fittedWidth, Math.max(0, this.hoverZoomPoint.x - rect.left - offsetX));
        const pointerY = Math.min(fittedHeight, Math.max(0, this.hoverZoomPoint.y - rect.top - offsetY));
        const progressX = fittedWidth ? pointerX / fittedWidth : 0.5;
        const progressY = fittedHeight ? pointerY / fittedHeight : 0.5;
        const zoomWidth = Math.max(naturalWidth, fittedWidth);
        const zoomHeight = Math.max(naturalHeight, fittedHeight);
        const left = offsetX - progressX * (zoomWidth - fittedWidth);
        const top = offsetY - progressY * (zoomHeight - fittedHeight);

        this.hoverZoom.style.width = `${zoomWidth}px`;
        this.hoverZoom.style.height = `${zoomHeight}px`;
        this.hoverZoom.style.left = `${left}px`;
        this.hoverZoom.style.top = `${top}px`;
        this.hoverZoom.classList.add('is-ready');
        this.stage.classList.add('is-magnifying');
      }

      hideHoverZoom() {
        this.hoverZoomActive = false;
        this.hoverZoomPoint = null;
        this.hoverZoom?.classList.remove('is-ready');
        this.stage?.classList.remove('is-magnifying');
      }

      isPurchasable(variant) {
        if (!variant || !variant.available) return false;

        const rule = variant.quantity_rule || {};
        if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
          const minimum = Number(rule.min) || 1;
          const inventory = variant.inventory_quantity;
          if (inventory != null && !Number.isNaN(Number(inventory)) && minimum > Number(inventory)) {
            return false;
          }
        }

        return true;
      }

      handleClick = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const optionButton = target.closest('[data-sc-option]');
        if (optionButton) {
          event.preventDefault();
          this.selectOption(Number(optionButton.dataset.scOption), optionButton.dataset.value || '');
          return;
        }

        const thumb = target.closest('[data-sc-thumb]');
        if (thumb) {
          event.preventDefault();
          this.activateMedia(thumb.dataset.mediaId);
          return;
        }

        if (target.closest('[data-sc-slide].is-active')) {
          event.preventDefault();
          this.openLightbox();
          return;
        }

        if (target.closest('[data-sc-zoom]')) {
          event.preventDefault();
          this.openLightbox();
          return;
        }

        if (target.closest('[data-sc-lightbox-close]')) {
          event.preventDefault();
          this.lightbox?.close();
          return;
        }

        if (target.closest('[data-sc-lightbox-prev]')) {
          event.preventDefault();
          this.stepLightbox(-1);
          return;
        }

        if (target.closest('[data-sc-lightbox-next]')) {
          event.preventDefault();
          this.stepLightbox(1);
          return;
        }

        if (target.closest('[data-sc-qty-minus]')) {
          event.preventDefault();
          this.stepQuantity(-1);
          return;
        }

        if (target.closest('[data-sc-qty-plus]')) {
          event.preventDefault();
          this.stepQuantity(1);
        }
      };

      selectOption(optionIndex, value) {
        if (Number.isNaN(optionIndex)) return;

        const nextSelection = this.selected.slice();
        nextSelection[optionIndex] = value;
        let variant = this.findVariant(nextSelection);

        if (!variant) {
          const candidates = this.variants.filter(
            (candidate) => this.normalize(candidate.options[optionIndex]) === this.normalize(value)
          );
          variant = candidates.find((candidate) => this.isPurchasable(candidate)) || candidates[0] || null;
          if (variant) {
            this.selected = Array.isArray(variant.options) ? variant.options.slice() : nextSelection;
          } else {
            this.selected = nextSelection;
          }
        } else {
          this.selected = nextSelection;
        }

        this.applyVariant(variant);
      }

      applyVariant(variant, options = {}) {
        this.currentVariant = variant || null;

        this.querySelectorAll('[data-sc-option]').forEach((button) => {
          const index = Number(button.dataset.scOption);
          const isSelected =
            Boolean(variant) &&
            this.normalize(variant.options[index]) === this.normalize(button.dataset.value);
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        this.querySelectorAll('[data-sc-option-value]').forEach((label) => {
          const index = Number(label.dataset.scOptionValue);
          label.textContent = variant && variant.options[index] ? variant.options[index] : '';
        });

        this.updateAvailability();

        if (variant && this.idInput) {
          this.idInput.value = String(variant.id);
        }

        if (this.priceCurrent) {
          this.priceCurrent.textContent = variant ? variant.price_money : '';
        }

        if (this.priceCompare) {
          const hasCompare = Boolean(variant) && Number(variant.compare_at_price) > Number(variant.price);
          this.priceCompare.textContent = hasCompare ? variant.compare_at_money : '';
          this.priceCompare.hidden = !hasCompare;
        }

        if (this.variantNote) {
          const note = variant && variant.note ? String(variant.note).trim() : '';
          this.variantNote.textContent = note;
          this.variantNote.hidden = !note;
        }

        if (this.variantRemark) {
          const remark = variant && variant.remark ? String(variant.remark).trim() : '';
          this.variantRemark.textContent = remark;
          this.variantRemark.hidden = !remark;
        }

        const unavailable = !this.isPurchasable(variant);

        if (this.atcButton) {
          this.atcButton.disabled = unavailable || this.isBusy;
        }
        this.updateAtcLabel();

        if (variant && variant.media_id) {
          this.activateMedia(String(variant.media_id));
        }

        this.syncQuantityLimits();

        if (variant && options.updateUrl !== false) {
          this.updateUrlVariant(variant.id);
        }

        this.dispatchEvent(
          new CustomEvent('seacube:variant-changed', {
            bubbles: true,
            detail: {
              variant,
              productId: this.dataset.productId || null,
            },
          })
        );
      }

      updateAvailability() {
        this.querySelectorAll('[data-sc-option]').forEach((button) => {
          const index = Number(button.dataset.scOption);
          const combination = this.selected.slice();
          combination[index] = button.dataset.value || '';
          const matches = this.matchVariants(combination);
          const hasAvailable = matches.some((variant) => this.isPurchasable(variant));

          button.classList.toggle('is-unavailable', !hasAvailable);
          button.setAttribute('aria-disabled', matches.length === 0 ? 'true' : 'false');
        });
      }

      updateAtcLabel() {
        if (!this.atcText || this.isBusy) return;
        this.atcText.textContent = this.isPurchasable(this.currentVariant) ? 'Add to cart' : 'Sold out';
      }

      activateMedia(mediaId) {
        if (!mediaId) return;
        const normalizedId = String(mediaId);
        const slides = Array.from(this.querySelectorAll('[data-sc-slide]'));
        const nextSlide = slides.find((slide) => slide.dataset.mediaId === normalizedId);
        if (!nextSlide) return;

        slides.forEach((slide) => {
          const isActive = slide === nextSlide;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        this.querySelectorAll('[data-sc-thumb]').forEach((thumb) => {
          const isActive = thumb.dataset.mediaId === normalizedId;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });

        this.hideHoverZoom();
        this.activeMediaId = normalizedId;
      }

      openLightbox() {
        if (!this.lightbox || !this.lightboxImage) return;

        this.hideHoverZoom();
        this.lightboxSlides = Array.from(this.querySelectorAll('[data-sc-slide]')).filter(
          (slide) => Boolean(slide.dataset.zoomSrc)
        );
        if (!this.lightboxSlides.length) return;

        const activeIndex = this.lightboxSlides.findIndex((slide) => slide.classList.contains('is-active'));
        this.lightboxIndex = activeIndex >= 0 ? activeIndex : 0;
        this.renderLightbox();

        if (typeof this.lightbox.showModal === 'function') {
          this.lightbox.showModal();
        } else {
          this.lightbox.setAttribute('open', '');
        }
      }

      renderLightbox() {
        if (!this.lightboxImage || !this.lightboxSlides.length) return;

        const slide = this.lightboxSlides[this.lightboxIndex];
        const image = slide.querySelector('img');
        this.lightboxImage.src = slide.dataset.zoomSrc || '';
        this.lightboxImage.alt = image ? image.alt : '';

        const hasMultipleImages = this.lightboxSlides.length > 1;
        if (this.lightboxPrevious) this.lightboxPrevious.disabled = !hasMultipleImages;
        if (this.lightboxNext) this.lightboxNext.disabled = !hasMultipleImages;
        if (this.lightboxCount) {
          this.lightboxCount.textContent = `${this.lightboxIndex + 1} / ${this.lightboxSlides.length}`;
        }
      }

      stepLightbox(direction) {
        if (this.lightboxSlides.length < 2) return;
        this.lightboxIndex =
          (this.lightboxIndex + direction + this.lightboxSlides.length) % this.lightboxSlides.length;
        this.renderLightbox();

        const slide = this.lightboxSlides[this.lightboxIndex];
        if (slide?.dataset.mediaId) this.activateMedia(slide.dataset.mediaId);
      }

      handleLightboxKeydown = (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.stepLightbox(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.stepLightbox(1);
        }
      };

      handleLightboxClick = (event) => {
        if (event.target === this.lightbox) {
          this.lightbox.close();
        }
      };

      getQuantityLimits(variant) {
        if (!variant) return { min: 1, max: null, step: 1 };

        const rule = variant.quantity_rule || {};
        const min = Math.max(1, Number(rule.min) || 1);
        const step = Math.max(1, Number(rule.increment) || 1);
        let max = rule.max == null ? null : Number(rule.max);

        if (
          max == null &&
          variant.inventory_management === 'shopify' &&
          variant.inventory_policy === 'deny'
        ) {
          max = Math.max(0, Number(variant.inventory_quantity) || 0);
        }

        return { min, max, step };
      }

      syncQuantityLimits() {
        if (!this.qtyInput) return;

        const limits = this.getQuantityLimits(this.currentVariant);
        this.qtyInput.min = String(limits.min);
        this.qtyInput.step = String(limits.step);

        if (limits.max == null) {
          this.qtyInput.removeAttribute('max');
        } else {
          this.qtyInput.max = String(limits.max);
        }

        let quantity = Math.floor(Number(this.qtyInput.value) || limits.min);
        if (quantity < limits.min) quantity = limits.min;
        if (limits.max != null && limits.max >= limits.min && quantity > limits.max) {
          quantity = limits.max;
        }
        this.qtyInput.value = String(quantity);
      }

      stepQuantity(direction) {
        if (!this.qtyInput) return;

        const limits = this.getQuantityLimits(this.currentVariant);
        if (limits.max != null && limits.max < limits.min) {
          this.showFeedback('This option is currently unavailable.', 'error');
          return;
        }

        const current = Math.floor(Number(this.qtyInput.value) || limits.min);
        let next = current + direction * limits.step;

        if (next < limits.min) next = limits.min;

        if (limits.max != null && next > limits.max) {
          next = limits.max;
          this.showFeedback(`Only ${limits.max} available.`, 'error');
        } else {
          this.clearFeedback();
        }

        this.qtyInput.value = String(next);
      }

      handleQuantityChange = () => {
        this.syncQuantityLimits();
      };

      updateUrlVariant(variantId) {
        if (window.Shopify && window.Shopify.designMode) return;

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variantId));
          window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        } catch (error) {
          /* Ignore browsers or contexts that do not allow history updates. */
        }
      }

      showFeedback(message, type) {
        if (!this.feedback) return;
        this.feedback.textContent = message;
        this.feedback.dataset.type = type || '';
        window.clearTimeout(this.feedbackTimer);
        this.feedbackTimer = window.setTimeout(() => this.clearFeedback(), 6000);
      }

      clearFeedback() {
        if (!this.feedback) return;
        this.feedback.textContent = '';
        this.feedback.removeAttribute('data-type');
        window.clearTimeout(this.feedbackTimer);
      }

      setBusy(busy) {
        this.isBusy = busy;
        if (!this.atcButton) return;
        this.atcButton.classList.toggle('is-busy', busy);
        this.atcButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        this.atcButton.disabled = busy || !this.isPurchasable(this.currentVariant);
        if (this.atcText) {
          this.atcText.textContent = busy ? 'Adding…' : this.isPurchasable(this.currentVariant) ? 'Add to cart' : 'Sold out';
        }
      }

      flashAdded() {
        if (!this.atcText) return;
        this.atcText.textContent = 'Added';
        window.clearTimeout(this.addedTimer);
        this.addedTimer = window.setTimeout(() => {
          if (!this.isBusy) this.updateAtcLabel();
        }, 1500);
      }

      handleSubmit = async (event) => {
        event.preventDefault();

        if (!this.currentVariant) {
          this.showFeedback('Please select a product option.', 'error');
          return;
        }

        if (!this.isPurchasable(this.currentVariant)) {
          this.showFeedback('This option is currently sold out.', 'error');
          return;
        }

        const limits = this.getQuantityLimits(this.currentVariant);
        let quantity = Math.floor(Number(this.qtyInput.value) || limits.min);

        if (quantity < limits.min) quantity = limits.min;

        if (limits.max != null && quantity > limits.max) {
          quantity = limits.max;
          this.qtyInput.value = String(quantity);
          this.showFeedback(`Only ${limits.max} available.`, 'error');
          return;
        }

        this.qtyInput.value = String(quantity);
        this.idInput.value = String(this.currentVariant.id);
        this.setBusy(true);
        this.clearFeedback();

        const formData = new FormData(this.form);
        formData.set('id', String(this.currentVariant.id));
        formData.set('quantity', String(quantity));

        const sectionIds = new Set();
        document.querySelectorAll('cart-items-component[data-section-id]').forEach((element) => {
          if (element instanceof HTMLElement && element.dataset.sectionId) {
            sectionIds.add(element.dataset.sectionId);
          }
        });
        if (sectionIds.size > 0) {
          formData.set('sections', Array.from(sectionIds).join(','));
        }

        try {
          const cartAddUrl =
            window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url
              ? window.Theme.routes.cart_add_url
              : '/cart/add.js';

          const response = await fetch(cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const data = await response.json();

          if (!response.ok || (data && data.status)) {
            throw new Error(
              (data && (data.description || data.message)) || 'Unable to add this item to cart.'
            );
          }

          this.setBusy(false);
          this.showFeedback('Added to cart.', 'success');
          this.flashAdded();

          this.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: this.dataset.sectionId || '',
                data: {
                  source: 'product-form-component',
                  itemCount: quantity,
                  productId: this.dataset.productId || null,
                  variantId: String(this.currentVariant.id),
                  sections: data && data.sections ? data.sections : undefined,
                },
              },
            })
          );
        } catch (error) {
          this.setBusy(false);
          this.showFeedback(
            error && error.message ? error.message : 'Unable to add this item to cart.',
            'error'
          );
        }
      };
    }

    customElements.define(TAG_NAME, SeaCubeProductMain);
  })();

  } catch(e) { console.error(e); }
})();
})();
